import React, {Component} from 'react';
import {hasUserRight, monthName, showAxiosError} from "./helper/helper";
import {request, requestOut} from "./helper/APIUtils";
import {Bar} from "react-chartjs-2";
import {Decimal} from 'decimal.js';
import {ACCESS_TOKEN, EntegratorConf, SERVLET_PATH, VirtualHost} from "./constants"
import moment from "moment";
import StickButton from "./components/StickButton";
import CreditHistoryModal from "./accounting/customer/components/CreditHistoryModal";
import SweetAlert from 'react-bootstrap-sweetalert';
import {Col, Row} from "reactstrap";
import PostpaidCustomerList from "./accounting/customer/components/PostpaidCustomerList";
import PayTrModal from "./accounting/paytr/PayTrModal";
import Select from "./local_node_modules/react-select"
import SmmmUserModal from "./accounting/smmmuserinformation/SmmmUserModal";
import CustomerRequiredFieldModal from "./accounting/smmmuserinformation/CustomerRequiredFieldModal";
import Swal from "sweetalert2";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {Modal, ModalFooter} from "react-bootstrap";
import {
	EntegratorIdentifiers,
	UserRightsEnum,
	VukApplicationState,
	VukApplicationTrackingStatus
} from "./helper/enums";
import EdefterApplicationModal from "./components/EdefterApplicationModal";
import InformationMailModal from "./accounting/customer/components/InformationMailModal";
import BankModal from "./accounting/customer/components/BankModal";
import {
	connectorPaymentExceptionUser,
	defterUnitName,
	isVakifbank,
	show100000AsUnlimited,
	showAnnouncement, showChemistInformationModal, showConnectorPayment, showConnectorPaymentKolay,
	showContactCard,
	showEdefterApplicationCard,
	showEdefterSecondCopyApplicationCard,
	showKalanBaro, showKolayAndSmart, showKolaySmartMbt, showKolaysoftPos, showOnlyZirve,
	showPaytrButton, showPosPayment, showSmmInformationModal,
} from "./helper/permission";
import EdefterSecondCopyApplicationModal from "./components/EdefterSecondCopyApplicationModal";
import DeniedInboxWithErrorList from "./components/DeniedInboxWithErrorList";
import cacheInstance from './components/cache/Cache'
import SgkAppointmentModal from "./accounting/sgkappointment/SgkAppointmentModal";
import Alert from "react-s-alert";
import VideoModal from "./components/VideoModal";
import OptikInformationModal from "./accounting/customer/components/OptikInformationModal";
import ChemistInformationModal from "./accounting/customer/components/ChemistInformationModal";
import purify from "dompurify";
import BekKvkkModal from "./accounting/customer/components/BekKvkkModal";
import {Image} from './common/Image';
import TelephoneModal from "./accounting/customer/components/TelephoneModal";
import ConnectorPaymentModal from "./accounting/connector/ConnectorPaymentModal";

class HomePage extends Component {

	static SHOW_NOTIFICATION = "showNotification";

	constructor(props) {
		super(props);
		this.state = {
			creditHistoryModal: false,
			totalData: {
				labels: ['Ocak', 'Şubat', 'Mart', 'Nisan',
					'Mayıs', 'Haziran', 'Temmuz', 'Ağustos',
					'Eylül', 'Ekim', 'Kasım', 'Aralık'],
				datasets: [],
				redirect: false
			},
			contentList: [],
			lastSgkInvoice: null,
			nextGocInvoice: null,
			nextInvoicePrefix: null,
			prefixForDisplay: null,
			showSmmInfoModal: false,
			showAnnouncementModal: false,
			showRequiredFiledModal: false,
			currentYear: ((new Date().getMonth() === 0 && new Date().getDate() < 15) ? (new Date().getFullYear() - 1) : new Date().getFullYear()),
			callCenterModal: false,
			edefterApplicationModal: false,
			eDefterSecondCopyApplicationModal: false,
			showCreditExpireModal: false,
			creditExpireList:[],
			informationMailEntegrator:[],
			appointmentMonth: ((new Date().getDate() < 15  ? new Date().getMonth()-1 : new Date().getMonth()) + 1),
			optionsYears:[],
			optionsCurrencyCode:null,
			selectedCurrencyCode: {label:"TL", value:"TRY"},
			announcemetList:[],
			surveyList:[],
			thisYear:new Date().getFullYear(),
			showDeniedInboxWithError:false,
			source:"homepage",
			informationMailCheck: true,
			purchaseAlan: false,
			selcukEczaCampaignModal: false,
			selcukEczacampaignSelection: "",
			chemistCampaignText: "",
			chemistCampaignModal: false,
			campaignLogo: "",
			prefixCodeTypes: [{value: "PrefixCode", label: "E-Fatura"}, {value: "EArsivPrefixCode", label: "E-Arşiv"}],
			selectedPrefixCodeType: "PrefixCode",
			prefixCodes: [],
			selectedPrefixCode: "",
			day: '',
			month: '',
			y: '',
			checkContractActive : 0,
			showBankModal:false,
			optikInfoModal:false,
			isCreditUser:false,
			isAreaUser:false,
			showEdefterApplicationVideoModal: false,
			isMobile : window.innerWidth > 991 ? false : true,
			showVuk507PosButton: false,
			hasVukApplication: false,
			vukApplicationState: "",
			vukApplicationTrackingNumber: undefined,
			vukApplicationSponsorName: undefined,
			vukApplicationTrackingStatus: undefined,
			showChemistInformationModal: false,
			showBekKvkkModal: false,
			entegratorConf: props.entegratorConf,
			vukApplicationList: [],
			devreyeAl:false,
			hasAppointment:null,
			hasAppointmentModal:false,
			withoutAppointment:false,
			selectedTimeline:null,
			timelineList: [],
			showTimeline: false,
			cancelAppointmentOk:false,
			posApprovedCheck: null,
			posApprovedModal: false,
			changeCepTelModal: false,
			customerSorumluCepTel: null,
			mandatoryAppointment:false,
			paymentUrl: "",
			showServiceFeeModal: false,
			eczaciposPaymentInfo: {},
			expireDate: null,
			connectorAlert: false,
			exceptionCustomer: false,
			announcementList: [],
			checkAnswer: false
		};

		this.getCount = this.getCount.bind(this);
		this.onClickDetail = this.onClickDetail.bind(this);
		this.showCreditHistory = this.showCreditHistory.bind(this);
		this.closeCreditHistoryModal = this.closeCreditHistoryModal.bind(this);
		this.closeShowSmmInfoModal = this.closeShowSmmInfoModal.bind(this);
		this.closePostpaidCustomerListModal = this.closePostpaidCustomerListModal.bind(this);
		this.checkIfSmmm = this.checkIfSmmm.bind(this);
		this.checkInformation = this.checkInformation.bind(this);
		this.checkAnnouncement = this.checkAnnouncement.bind(this);
		this.checkSurvey = this.checkSurvey.bind(this);
		this.checkCardAnnouncement = this.checkCardAnnouncement.bind(this);
		this.handleCloseCallCenterModal = this.handleCloseCallCenterModal.bind(this);
		this.openEdefterApplicationModal = this.openEdefterApplicationModal.bind(this);
		this.closeEdefterApplicationModal = this.closeEdefterApplicationModal.bind(this);
		this.checkCreditExpire = this.checkCreditExpire.bind(this);
		this.modifyDate = this.modifyDate.bind(this);
		this.informationMailChange = this.informationMailChange.bind(this);
		this.openEdefterSecondCopyApplicationModal = this.openEdefterSecondCopyApplicationModal.bind(this);
		this.closeEdefterSecondCopyApplicationModal = this.closeEdefterSecondCopyApplicationModal.bind(this);
		this.startInitial = this.startInitial.bind(this);
		this.checkDeniedInboxWithError = this.checkDeniedInboxWithError.bind(this);
		this.setValue = this.setValue.bind(this);
		this.confirmSelcukEczaCampaign = this.confirmSelcukEczaCampaign.bind(this);
		this.checkSelcukCampaign = this.checkSelcukCampaign.bind(this);
		this.fetchPrefixData = this.fetchPrefixData.bind(this);
		this.nextInvoicePrefix = this.nextInvoicePrefix.bind(this);
		this.checkContractActive = this.checkContractActive.bind(this);
		this.checkIfIbanExist = this.checkIfIbanExist.bind(this);
		this.closeShowBankModal = this.closeShowBankModal.bind(this);
		this.closeOptikInfoModal = this.closeOptikInfoModal.bind(this);
		this.checkNecessitiesForOgo = this.checkNecessitiesForOgo.bind(this);
		this.getUnitType = this.getUnitType.bind(this);
		this.mikrokomHashBuyKontor = this.mikrokomHashBuyKontor.bind(this);
		this.checkKalanBakiye = this.checkKalanBakiye.bind(this);
		this.checkCreditExpiration = this.checkCreditExpiration.bind(this);
		this.checkShowBuyButton = this.checkShowBuyButton.bind(this);
		this.renderVukApplicationInfo = this.renderVukApplicationInfo.bind(this);
		this.additionalDeviceApplication = this.additionalDeviceApplication.bind(this);
		this.setVukApplicationStatus = this.setVukApplicationStatus.bind(this);
		this.customerHasAppointment = this.customerHasAppointment.bind(this);
		this.handleCloseModal = this.handleCloseModal.bind(this);
		this.fetchTimeline = this.fetchTimeline.bind(this);
		this.approvedPosCheck = this.approvedPosCheck.bind(this);
		this.checkEczaciCepTel = this.checkEczaciCepTel.bind(this);
		this.checkAppointment = this.checkAppointment.bind(this);
		this.redirectToPayment = this.redirectToPayment.bind(this);
		this.checkPendingServiceFee = this.checkPendingServiceFee.bind(this);
		this.getAnnouncements = this.getAnnouncements.bind(this);
	}

	lastInvoice = (year, prefix, name) => {
		request({
			url: `/invoiceTmp/next-invoice?year=${year}&prefix=${prefix}&prefixCodeType=PrefixCode`,
			method: "get",
		}).then(response => {
			this.setState({[name]: response.data});
		}).catch(error => {
			showAxiosError(error);
		});
	};

	nextInvoicePrefix = (prefix) => {
		request({
			url: `/invoiceTmp/next-invoice?year=${this.state.currentYear}&prefix=${prefix}&prefixCodeType=${this.state.selectedPrefixCodeType}`,
			method: "get",
		}).then(response => {
			this.setState({
				nextInvoicePrefix: response.data,
				prefixForDisplay: prefix
			});
		}).catch(error => {
			showAxiosError(error);
		});
	};

	fetchPrefixData() {
		let self = this;
		let params = {
			url: `/invoiceTmp/getInvoicePrefixData/${self.state.selectedPrefixCodeType}`,
			method: "get",
		}
		request(params)
			.then(response => {
				let prefixCodes = [];
				response.data.map(prefix => {
					prefixCodes.push({value: prefix.key, label: prefix.key});
				});
				self.setState({prefixCodes, selectedPrefixCode: (prefixCodes.length>0 ? prefixCodes[0].value : "")});
				self.nextInvoicePrefix(self.state.selectedPrefixCode);
			}).catch(function (error) {
			showAxiosError(error);
		});
	}

	activeYears = [
		{value: new Date().getFullYear(), label: new Date().getFullYear()},
		{value: (new Date().getFullYear() - 1), label: (new Date().getFullYear() - 1)},
	];

	getUnitType(unit) {
		if (unit === 1) {
			return ("Kontör Adeti");
		} else if (unit === 2) {
			return (defterUnitName(EntegratorConf.identifier));
		} else if (unit === 3) {
			return ("e-Arşiv Kasa")
		} else {
			return ("Birim Yok");
		}
	}

	getAnnouncements(){
		request({
			url: `/announcements/getAnnouncements`,
			method: 'get'
		}).then(response => {
			if (response.data && response.data.announcementList) {
				this.setState({announcementList: response.data.announcementList});
			}
		}).catch(error => {
			console.log("getAnnouncements", error);
		});
	}

	componentDidMount() {
		this.getConnectionInfo();
		this.getAnnouncements();
		//this.fetchTimeline();
		let self = this;
		let thisYear = self.state.thisYear;
		let optionsYears = [
			{label:(thisYear-1).toString(), value:thisYear-1},
			{label:(thisYear).toString(), value:thisYear}
		];
		let optionsCurrencyCode = [
			{label:"TL", value:"TRY"},
			{label:"USD", value:"USD"},
			{label:"EUR", value:"EUR"}
		];
		self.setState({optionsYears, thisYear, optionsCurrencyCode});
		self.startInitial();

		let d = new Date();
		d.setDate(d.getDate()-1);
		let day = d.getDate();
		let month = d.getMonth()+1;
		let y = d.getFullYear();

		self.setState({day: day <=9 ? '0' + day : day,
							month: month <=9 ? '0' + month : month,
							y: y});
		self.setUserType();
		let poorServiceList = self.props.currentUser.poorServiceList;
		if(poorServiceList && poorServiceList.length>0){
			let announcemetList = self.state.announcemetList;
			announcemetList.push({
				title: '',
				html: 'Yeterli kontör bulunmayan hizmetlerinizin kullanımı kısıtlanmış olup,' +
					'Hizmetlerin kullanımına devam etmek için kontör yükleme yapmanız gerekmektedir.',
				text: 'Yeterli kontör bulunmayan hizmetlerinizin kullanımı kısıtlanmış olup,' +
					'Hizmetlerin kullanımına devam etmek için kontör yükleme yapmanız gerekmektedir.',
				type: '',
				animation: false,
				width: "43rem",
				allowOutsideClick: false,
				allowEnterKey: false,
				confirmButtonText: "Tamam",
				padding: "0.80rem",
				reverseButtons: true
			});
			self.setState({announcemetList});
			Swal.queue(announcemetList);
		}
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps && nextProps.entegratorConf !== this.state.entegratorConf) {
			if (nextProps.entegratorConf.vuk507PosQueryUrl) {
				this.setState({entegratorConf: nextProps.entegratorConf}, () => {
					this.checkVuk507ApplicationStatus();
				});
			}
		}
	}

	checkContractActive() {
		request({
			url: `/customer/isContractActive`,
			method: "get",
		}).then(response => {
			this.setState({checkContractActive: response.data});
		}).catch(error => {
			showAxiosError(error);
		});
	};

	startInitial(){
		let self = this;

		self.checkContractActive();

		if (showPaytrButton(self.props.currentUser.parentCustomerWorkType, self.state.entegratorConf.identifier)
			|| VirtualHost.conf.resourcePrefix === "musavir"
			|| showSmmInformationModal(self.props.currentUser.parentCustomerId)) {
			self.checkInformation();
			if (showSmmInformationModal(self.props.currentUser.parentCustomerId))
				self.checkIfSmmm();
		}

		if( self.isEczaciKart() || self.isOgo() || self.isIsitmeMerkezi()  || self.isTestud()){
			self.checkIfIbanExist();
		}

		if (self.isOgo()){
			self.checkNecessitiesForOgo()
		}

		// if (!self.props.currentUser.impersonate) {
		// 	self.checkSelcukCampaign();
		// }

		if (self.isEczaciKart() && [28839,30735,15829].includes(self.props.currentUser.parentCustomerId)) {
			if (self.props.currentUser.parentCustomerId === 28839) {
				self.setState({
					chemistCampaignText: "Selçuk Ecza ve As Ecza Deposu kampanyasından faydalanmaktasınız.",
					campaignLogo: "selcuk_as_campaign"
				});
			} else if (self.props.currentUser.parentCustomerId === 15829) {
				self.setState({
					chemistCampaignText: "Bursa Ecza Koop kampanyasından faydalanmaktasınız.",
					campaignLogo: "bek_campaign"
				});
			} else if (self.props.currentUser.parentCustomerId === 30735) {
				self.setState({
					chemistCampaignText: "Nevzat Ecza Deposu kampanyasından faydalanmaktasınız.",
					campaignLogo: "nevzat_campaign"
				});
			}
		}

		if (self.isEFatura()) {
			if (hasUserRight(UserRightsEnum.invoice.viewIncoming, self.props.currentUser))
				self.getCount("inbox");
			if (hasUserRight(UserRightsEnum.invoice.view, self.props.currentUser))
				self.getCount("outbox");
		}

		if (self.isEArsiv()) {
			if (hasUserRight(UserRightsEnum.earchive.view, self.props.currentUser))
				self.getCount("archive");
		}

		if (self.isEIrsaliye()) {
			if (hasUserRight(UserRightsEnum.despatch.viewIncoming, self.props.currentUser))
				self.getCount("despatchInbox");

			if (hasUserRight(UserRightsEnum.despatch.view, self.props.currentUser))
				self.getCount("despatchOutbox");
		}

		if (self.isEMM()) {
			if (hasUserRight(UserRightsEnum.voucher.mmView, self.props.currentUser))
				self.getCount("mVoucher");
		}

		if (self.isExchange()) {
			if (hasUserRight(UserRightsEnum.exchange.view, self.props.currentUser))
				self.getCount("exchange");
		}

		if (self.isESMM()) {
			if (hasUserRight(UserRightsEnum.voucher.smmView, self.props.currentUser))
				self.getCount("sVoucher");
		}

		if(self.isEGiderPusulasi()){
			if(hasUserRight(UserRightsEnum.newExpenseNote.view, self.props.currentUser))
				self.getCount("expenseNote");
		}

		if (self.isEczaciKart() || self.isOgo() || self.isIsitmeMerkezi() || self.isMedikal() || self.isTestud()) {
			self.lastInvoice(self.state.currentYear, "SGK","lastSgkInvoice");
		}

		if (self.isEczaciKart() || self.isTestud()) {
			self.lastInvoice(self.state.currentYear,"GOC","nextGocInvoice");
		}

		if (self.hasEBelge()) {
			self.getCount("ebelgeSend");
			self.getCount("ebelgeIn");
		}

		if (self.isReceipt()){
			self.getCount("receipt");
		}

		if (self.isESigorta()){
			self.getCount("sigorta");
		}

		self.getCount("currency");
		self.getCount("credit");
		self.getCount("memory");

		if(self.isEArsiv() && ['interpos', 'bilnex'].includes(VirtualHost.conf.resourcePrefix))
			self.getCount("fieldCredit");

		if (showAnnouncement()) {
			if (!this.props.currentUser.impersonate) {
				this.checkAnnouncement(() => {
					if (self.isEczacıKartFatura()){
						self.checkSurvey();
					}
				});
			}
			this.checkCardAnnouncement(() => {
				if (self.isEczacıKartFatura() && !this.props.currentUser.impersonate){
					self.checkSurvey();
				}
			});
		} else {
			if (self.isEczacıKartFatura() && !this.props.currentUser.impersonate){
				self.checkSurvey();
			}
		}

		if(showOnlyZirve() || showKolaySmartMbt(self.state.entegratorConf.identifier))
			self.checkCreditExpire();

		if( self.props.location.pathname === "/" ){
			self.props.enableAutoShowDefterSecondCopyNotification();
		}

		if (self.isEczaciKart() || self.isTestud()) {
			self.fetchPrefixData();
		}
		//self.checkDeniedInboxWithError();

		if (self.isEczaciKart()) {
			self.checkVuk507ButtonShow();
			self.customerHasAppointment();
		}

		if (showChemistInformationModal()) {
			self.checkChemistInformationModalShow()
		}

		if ([EntegratorIdentifiers.KOLAYSOFT].includes(this.state.entegratorConf.identifier) && !self.props.currentUser.impersonate) {
			self.checkNeedBekKvkkSign();
		}

		if (self.isEczaciKart() && [5925, 15829, 16103,46486,28839,30735].includes(self.props.currentUser.parentCustomerId)) {
			self.checkEczaciCepTel();
		}
		if (showConnectorPayment(EntegratorConf.identifier)){
			self.checkExpireDateControl();
		}

	}

	checkAnnouncement(callback) {
		let resp;
		request({
			url: `/announcement/checkAnnouncement`,
			method: 'post'
		}).then(response => {
			if (response.data && Array.isArray(response.data) && response.data.length > 0) {
				resp = response;
				let announcemetList = this.state.announcemetList;
				resp.data.map(ar => (
					announcemetList.push({
						title: '',
						html: ar.contentResult,
						text: ar.contentResult,
						type: '',
						animation: false,
						width: "43rem",
						allowOutsideClick: false,
						allowEnterKey: false,
						confirmButtonText: "Kapat( " + ar.remainingShow + " )",
						padding: "0.80rem",
						reverseButtons: true
					})
				));
				this.setState({announcemetList});
				Swal.queue(announcemetList).then((result) => {
					let requestData = [];
					if (result.dismiss === Swal.DismissReason.cancel) {
						resp.data.map(r => (
							requestData.push({
								'recordId': r.recordId,
								'count': -1
							})
						));
					} else if (result.value && Array.isArray(result.value)) {
						resp.data.map(r => (
							requestData.push({
								'recordId': r.recordId,
								'count': 1
							})
						));
					}

					if (requestData && Array.isArray(requestData)) {
						request({
							url: `/announcement/updateRemainingShowCount`,
							method: 'post',
							data: requestData
						}).then(ignored => {
						}).catch(exception => {
							console.log("updateRemainingShowCount - Exception", exception);
						});
					}
					if (callback) callback();
				}).catch(error => {
					console.log("checkAnnouncement", error);
					if (callback) callback();
				});
			} else if (callback){
				callback();
			}
		}).catch(error => {
			console.log("checkAnnouncement", error);
			if (callback) callback();
		});
	}

	checkSurvey() {
		request({
			url: `/survey/checkSurvey`,
			method: 'post'
		}).then(response => {
			if (response.data && Array.isArray(response.data) && response.data.length > 0 && [EntegratorIdentifiers.KOLAYSOFT].includes(this.state.entegratorConf.identifier)) {
				let surveyList = response.data.map(ar => ({
					title: ar.title,
					html: `
                    <style>
                        .survey-container {
                            text-align: center;
                            font-size: 1.1rem;
                        }
                        .survey-options {
                            display: flex;
                            flex-direction: column;
                            justify-content: center;
                            align-items: center;
                            margin-top: 10px;
                            gap: 2px;
                        }
                        .survey-options label {
                            display: flex;
                            align-items: center;
                            justify-content: flex-start;
                            width: auto;
                            padding: 10px;
                            border: 1px solid #ddd;
                            border-radius: 5px;
                            background-color: #f8f9fa;
                            cursor: pointer;
                            transition: 0.3s;
                        }
                        .survey-options label:hover {
                            background-color: #e2e6ea;
                        }
                        .swal2-radio {
                            margin-right: 10px;
                        }
                    </style>
                    <div class="survey-container">
                        <p>${ar.contentResult}</p>
                        <div class="survey-options">
                            ${ar.options
						.sort((a, b) => a.recordId - b.recordId)
						.map(option => `
                                    <label class="survey-option">
                                        <input type="radio" class="swal2-radio" name="survey_${ar.recordId}" value="${option.recordId}">
                                        ${option.optionContent}
                                    </label>
                                `).join('')}
                        </div>
                    </div>`,
					input: null,
					animation: true,
					width: "43rem",
					allowOutsideClick: false,
					allowEnterKey: false,
					confirmButtonText: "Gönder",
					padding: "0.80rem",
					reverseButtons: true,
					preConfirm: () => {
						const selectedRadio = document.querySelector(`input[name="survey_${ar.recordId}"]:checked`);
						if (selectedRadio) {
							return this.submitSurvey(selectedRadio.value, ar.recordId);
						} else {
							Swal.showValidationMessage("Bir seçenek seçmelisiniz!");
							return false;
						}
					}
				}));
				Swal.queue(surveyList);
			}
		}).catch(error => {
			console.log("checkSurvey", error);
		});
	}

	submitSurvey(surveyOptionsId, surveyId) {
		const requestData = {
			surveyId: surveyId,
			surveyOptionsId: surveyOptionsId
		}
		request({
			url: `/survey/submitSurvey`,
			method: 'post',
			data: requestData
		}).then(response => {
			Alert.success(response.data, {
				position: 'top-right',
				effect: 'stackslide',
				timeout: 5000,
				html: false
			});
		}).catch(error => {
			Alert.error(error.response.data, {
				position: 'top-right',
				effect: 'stackslide',
				timeout: 5000,
				html: false
			});
		});
	}

	checkConnectorPaymentExceptionCustomer() {
		return new Promise((resolve) => {
			let self = this;
			let params = {
				url: "/connector/getAllConnectorPaymentExceptionCustomer",
				method: "get"
			};
			request(params).then((response) => {
				let exceptionCustomerVknTckns = response.data;
				let exceptionCustomer = connectorPaymentExceptionUser(EntegratorConf.identifier,this.props.currentUser.vknTckn,exceptionCustomerVknTckns);
				resolve(exceptionCustomer);
			})
				.catch((error) => {
					if (error.response && error.response.data) {
						Alert.error(error.response.data, {
							position: 'top-right',
							effect: 'stackslide',
							timeout: 5000,
							html: false
						});
					} else {
						Alert.error("Bilinmeyen bir hata oluştu.", {
							position: 'top-right',
							effect: 'stackslide',
							timeout: 5000,
							html: false
						});
					}
				});
		});
	}

	checkKalanBakiye() {
		if (showOnlyZirve()) {
			let kalanCredit = this.state.kalanCredit;
			let announcemetList = this.state.announcemetList;
			if (kalanCredit && kalanCredit <= 0) {
				let message = "<p style={{" +
					"fontSize: '14px'," +
					"fontFamily: 'Helvetica Neue, Helvetica, Arial, sans-serif'," +
					"fontWeight: 'bold',\n" +
					"textAlign: 'center',\n" +
					"marginBottom: '0'\n" +
					"}}>Kontörünüz bitmiştir. Satın almak için lütfen " +
					"<a href='https://online.zirveyazilim.net/online/hizli-kontor-islemleri'\n" +
					"target='_blank'> tıklayınız!\n" +
					"</a>" +
					"</p>";
				announcemetList.push({
					title: '',
					html: message,
					text: message,
					type: '',
					animation: false,
					width: "43rem",
					allowOutsideClick: false,
					allowEnterKey: false,
					confirmButtonText: "Tamam",
					padding: "0.80rem",
					reverseButtons: true
				});
				this.setState({announcemetList});
				Swal.queue(announcemetList);
			}
		}
	}

	checkCreditExpiration(creditExpireList){
		let announcemetList = this.state.announcemetList;
		if (showOnlyZirve()) {
			if (this.state.showCreditExpireModal && (!localStorage.getItem("showingTime") || (parseInt(localStorage.getItem("showingTime")) > 0))) {
				let message = "<div style='padding:10px'><table>" +
					"<tr style='font-size: 14px'>" +
					"<th>Yükleme Tarihi</th>" +
					"<th>Başlangıç Tarihi</th>" +
					"<th>Bitiş Tarihi</th>" +
					"<th>Kalan Süre (Gün)</th>" +
					"<th>Birim</th>" +
					"<th>Miktar</th>" +
					"</tr>";
				for (let i =0; i < creditExpireList.length ; i++) {
						message = message + "<tr style='font-size: 13px'>" + "<td>" + this.modifyDate(creditExpireList[i][0]) + "</td>";
						message = message + "<td>" + this.modifyDate(creditExpireList[i][1]) + "</td>";
						message = message + "<td>" + this.modifyDate(creditExpireList[i][2]) + "</td>";
						message = message + "<td>" + creditExpireList[i][3] + "</td>";
						message = message + "<td>" + this.getUnitType(creditExpireList[i][4]) + "</td>";
						message = message + "<td>" + creditExpireList[i][5] + "</td>";
						message = message + "</tr>";
				}
				message = message + "</table></div>";
				message = message + "" +
					"<p style='font-size: 16px; margin-top: 18px; text-align: center; margin-bottom: -18px'>" +
					"Süresi 1 ay içerisinde bitecek kontörleriniz yukarıda listelenmektedir satın almak için lütfen" +
					"<a href='https://online.zirveyazilim.net/online/hizli-kontor-islemleri'" +
					"   target='_blank'> tıklayınız!" +
					"</a>" +
					"</p>" +
					"";
				let count = localStorage.getItem("showingTime")? parseInt(localStorage.getItem("showingTime")) : 10;
				announcemetList.push({
					title: '',
					html: message,
					text: message,
					type: '',
					animation: false,
					width: "43rem",
					allowOutsideClick: false,
					allowEnterKey: false,
					confirmButtonText: `Tamam(${count})`,
					padding: "0",
					preConfirm: (ignored)=>{
						this.setState({showCreditExpireModal: false}, () => localStorage.setItem("showingTime", JSON.stringify(count-1)));
					}
				});
				this.setState({announcemetList});
				Swal.queue(announcemetList);
			}
		}else if (showKolaySmartMbt(this.state.entegratorConf.identifier)){
			if (this.state.showCreditExpireModal && (!localStorage.getItem("showingTime") || (parseInt(localStorage.getItem("showingTime")) > 0))) {
				let message = "<div style='padding:10px'><table>" +
					"<tr style='font-size: 14px'>" +
					"<th>Yükleme Tarihi</th>" +
					"<th>Başlangıç Tarihi</th>" +
					"<th>Bitiş Tarihi</th>" +
					"<th>Kalan Süre (Gün)</th>" +
					"<th>Birim</th>" +
					"<th>Miktar</th>" +
					"</tr>";
				for (let i =0; i < creditExpireList.length ; i++) {
					message = message + "<tr style='font-size: 13px'>" + "<td>" + this.modifyDate(creditExpireList[i][0]) + "</td>";
					message = message + "<td>" + this.modifyDate(creditExpireList[i][1]) + "</td>";
					message = message + "<td>" + this.modifyDate(creditExpireList[i][2]) + "</td>";
					message = message + "<td>" + creditExpireList[i][3] + "</td>";
					message = message + "<td>" + this.getUnitType(creditExpireList[i][4]) + "</td>";
					message = message + "<td>" + creditExpireList[i][5] + "</td>";
					message = message + "</tr>";
				}
				message = message + "</table></div>";
				message = message + "" +
					"<p style='font-size: 16px; margin-top: 18px; text-align: center; margin-bottom: -18px'>" +
					"Süresi 1 ay içerisinde bitecek kontörleriniz yukarıda listelenmektedir."+
					"</p>" +
					"";
				let count = localStorage.getItem("showingTime")? parseInt(localStorage.getItem("showingTime")) : 10;
				announcemetList.push({
					title: '',
					html: message,
					text: message,
					type: '',
					animation: false,
					width: "43rem",
					allowOutsideClick: false,
					allowEnterKey: false,
					showCancelButton: true,
					cancelButtonText: `Tamam(${count})`,
					padding: "0",
					confirmButtonText: `Kontör Satın Al`,
					showConfirmButton : this.checkShowBuyButton(),
					preConfirm: (ignored)=>{
						this.setState({showCreditExpireModal: false, showPayTrModal: true});
					},
					onClose: () => {
						this.setState({showCreditExpireModal: false}, () => localStorage.setItem("showingTime", JSON.stringify(count-1)));
					}
				});
				this.setState({announcemetList});
				Swal.queue(announcemetList);
			}
		}
	}

	 formatDate(dateString) {
		let date = new Date(dateString);
		let day = String(date.getDate()).padStart(2, '0');
		let month = String(date.getMonth() + 1).padStart(2, '0');
		let year = date.getFullYear();
		return `${day}-${month}-${year}`;
	}

	getConnectionInfo = async()=>{
		let self = this;
		let params = {
			url: `/connector/getConnectionInfo`,
			method: "post"
		};
		try{
			let {data} = await request(params);
			if(data!=null){
				self.setState({connectionInfo:data});
			}
		}catch(error){
			//let err = {response:{data:"Konnektör Bulunamadı"}}
			//showAxiosError(err);
		}
	}

	async checkExpireDate(creditExpireList){
		let exceptionCustomer = await this.checkConnectorPaymentExceptionCustomer();
		if (showConnectorPayment(this.state.entegratorConf.identifier) && !exceptionCustomer) {
			if (this.state.showExpireDateModal && (!localStorage.getItem("showingTimeConnector") || (parseInt(localStorage.getItem("showingTimeConnector")) > 0))) {
				let message = "<div style='padding:10px'><table>" +
					"<tr style='font-size: 14px'>" +
					"<th>Başlangıç Tarihi</th>" +
					"<th>Bitiş Tarihi</th>" +
					"<th>Kalan Süre (Gün)</th>" +
					"</tr>";
				for (let i =0; i < creditExpireList.length ; i++) {
					let today = new Date();
					today.setHours(0, 0, 0, 0);

					let expireDate = new Date(creditExpireList[i].expireDate);
					expireDate.setHours(0, 0, 0, 0);

					let timeDiff = expireDate - today;
					let daysRemaining = Math.floor(timeDiff / (1000 * 3600 * 24));
					let newDaysRemaining = daysRemaining >= 0 ? daysRemaining + " " + "gün sonra bitecektir" :
						Math.abs(daysRemaining) + " " + "gün önce bitmiştir";

					message = message + "<tr style='font-size: 13px'>";
					message = message + "<td>" + this.formatDate(creditExpireList[i].startDate) + "</td>";
					message = message + "<td>" + this.formatDate(creditExpireList[i].expireDate) + "</td>";
					message = message + "<td>" + newDaysRemaining + "</td>";
					message = message + "</tr>";
				}
				message = message + "</table></div>";
				message = message + "" +
					"<p style='font-size: 16px; margin-top: 18px; text-align: center; margin-bottom: -18px'>" +
					"Konnektör sözleşmeniz yukarda belirtilen kalan gün içerisinde bitecektir. Güncelleme ücreti ödeyerek kullanmaya devam edebilirsiniz."+
					"</p>" +
					"";
				let count = localStorage.getItem("showingTimeConnector")? parseInt(localStorage.getItem("showingTimeConnector")) : 10;
				Swal.fire({
					title: '',
					html: message,
					type: '',
					animation: false,
					width: "43rem",
					allowOutsideClick: false,
					allowEnterKey: false,
					showCancelButton: true,
					confirmButtonText: "Ödeme Yap",
					cancelButtonText: `Tamam (${count})`,
					padding: "0",
					preConfirm: () => {
						return new Promise((resolve) => {
							this.setState({ showCreditExpireModal: false, connectorPaymentModal: true, connectorAlert: true }, resolve);
						});
					}
				}).then((result) => {
					if (result.dismiss === Swal.DismissReason.cancel) {
						this.setState({ showCreditExpireModal: false }, () => {
							if (count > 0) {
								localStorage.setItem("showingTimeConnector", JSON.stringify(count - 1));
							}
						});
					}
				});
			}
		}
	}

	checkShowBuyButton(){
		return this.props.currentUser &&
			(
				(
					![3, 4].includes(this.props.impersonateUserRoleId) &&
					![15795].includes(this.props.currentUser.parentCustomerId) &&
					showPaytrButton(this.props.currentUser.parentCustomerWorkType, this.state.entegratorConf.identifier)
				)
				||
				(this.hasOnlyEBelge() &&  this.props.currentUser.parentCustomerId === 3248 && EntegratorIdentifiers.SMART === this.state.entegratorConf.identifier)
			);
	}

	checkCardAnnouncement(callback) {
		request({
			url: `/announcement/checkCardAnnouncement`,
			method: 'post'
		}).then(response => {
			if (response.data && response.data.contentList && response.data.contentList.length > 0) {
				this.setState({ contentList: response.data.contentList }, () => {
					if (callback) callback();
				});
			} else {
				callback();
			}
		}).catch(error => {
			console.log("checkCardAnnouncement error:", error);
		});
	}

	checkEczaciKartSurvey() {
		return new Promise((resolve) => {
			let params = {
				url: `/user/checkEczaciKartSurvey`,
				method: 'get'
			};
			request(params)
				.then((response) => {
					let result = response.data;
					resolve(result);
			})
				.catch((error) => {
					if (error.response && error.response.data) {
						Alert.error(error.response.data, {
							position: 'top-right',
							effect: 'stackslide',
							timeout: 5000,
							html: false
						});
					} else {
						Alert.error("Bilinmeyen bir hata oluştu.", {
							position: 'top-right',
							effect: 'stackslide',
							timeout: 5000,
							html: false
						});
					}
				});
		});
	}

	checkIfSmmm() {
		request({
			url: `/smmmUserInformation/checkIfSmmm`,
			method: 'get'
		}).then(response => {
			if (response.data && response.data === true)
				this.setState({showSmmInfoModal: true});
		}).catch(error => {
			showAxiosError(error);
		});
	}

	checkInformation() {
		request({
			url: `/checkinformation/checkInformation`,
			method: 'post'
		}).then(response => {
			let requiredField = response.data;
			this.setState({showRequiredFiledModal: requiredField.status, requiredField});
		}).catch(error => {
			showAxiosError(error);
		});
	}

	checkIfIbanExist() {
		request({
			url: `/customer/checkIfBankInfo`,
			method: 'get'
		}).then(response => {
			if (response.data === true)
				this.setState({showBankModal: true});
		}).catch(error => {
			showAxiosError(error);
		});
	}

	checkNecessitiesForOgo(){
		request({
			url: `/customer/checkNecessitiesForOgo`,
			method: 'get'
		}).then(response => {
			if (response.data.length !== 0)
				this.setState({optikInfoModal: true, optikInfoData: response.data});
		}).catch(error => {
			showAxiosError(error);
		});
	}

	closeShowBankModal() {
		this.setState({
			showBankModal: false
		});
	}

	closeOptikInfoModal() {
		this.setState({
			optikInfoModal: false
		});
	}

	getCount(type) {
		let self = this;
		let currencyCode = self.state.selectedCurrencyCode ? self.state.selectedCurrencyCode.value : "TRY";
		let data = {
			type: type,
			year: self.state.thisYear,
			currencyCode: currencyCode
		}

		let key = type + '-' + self.state.thisYear + '-' + currencyCode;

		let params = {
			url: `/homepage/infos`,
			method: "post",
			data: data
		};

		cacheInstance.get(key).then(responseObject => {
			if (responseObject) {
				self.setValue(type, responseObject);
			} else {
				request(params)
					.then(response => {
						if(response.data) {
							self.setValue(type, response.data);
							cacheInstance.set(key, response.data);
						}
					}).catch(function (error) {
					showAxiosError(error);
				});
			}
		});
	}

	setValue(type, responseObject){
		let self = this;
		let isContractActive = self.state.checkContractActive === 1;
		if (type === "inbox") {
			let inboxConsumes = [0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00];
			let tInboxConsumes = responseObject.inboxConsumes;
			for (let i = 0; i < tInboxConsumes.length; i++) {
				inboxConsumes[tInboxConsumes[i][1] - 1] = tInboxConsumes[i][0];
			}
			let totalData = self.state.totalData;
			totalData.datasets.push({
				label: 'Gelen Fatura Tutarı',
				type: "line",
				backgroundColor: 'rgba(255,99,132,0.2)',
				borderColor: 'rgba(255,99,132,1)',
				borderWidth: 1,
				hoverBackgroundColor: 'rgba(255,99,132,0.4)',
				hoverBorderColor: 'rgba(255,99,132,1)',
				data: inboxConsumes
			});
			self.setState({inboxCount: responseObject.inboxCount, totalData});
		} else if (type === "outbox") {
			let outboxConsumes = [0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00];
			let tOutboxConsumes = responseObject.outboxConsumes;
			for (let i = 0; i < tOutboxConsumes.length; i++) {
				outboxConsumes[tOutboxConsumes[i][1] - 1] = tOutboxConsumes[i][0];
			}
			let totalData = self.state.totalData;
			totalData.datasets.push({
				label: 'Giden Fatura Tutarı',
				type: "line",
				backgroundColor: 'rgba(105,231,129,0.2)',
				borderColor: 'rgba(105,231,129,1)',
				borderWidth: 1,
				hoverBackgroundColor: 'rgba(105,231,129,0.4)',
				hoverBorderColor: 'rgba(105,231,129,1)',
				data: outboxConsumes
			});
			self.setState({outboxCount: responseObject.outboxCount, totalData});
		} else if (type === "archive") {
			let archiveConsumes = [0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00];
			let tArchiveConsumes = responseObject.archiveConsumes;
			for (let i = 0; i < tArchiveConsumes.length; i++) {
				archiveConsumes[tArchiveConsumes[i][1] - 1] = tArchiveConsumes[i][0];
			}
			let totalData = self.state.totalData;
			totalData.datasets.push({
				label: 'E-Arşiv Fatura Tutarı',
				type: "line",
				backgroundColor: 'rgba(239,200,74,0.2)',
				borderColor: 'rgba(239,200,74,1)',
				borderWidth: 1,
				hoverBackgroundColor: 'rgba(239,200,74,0.4)',
				hoverBorderColor: 'rgba(239,200,74,1)',
				data: archiveConsumes
			});
			self.setState({archiveCount: responseObject.archiveCount, totalData});
		} else if (type === "despatchInbox") {
			let inboxConsumes = [0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00];
			let tInboxConsumes = responseObject.despatchInboxConsumes;
			for (let i = 0; i < tInboxConsumes.length; i++) {
				inboxConsumes[tInboxConsumes[i][1] - 1] = tInboxConsumes[i][0];
			}
			let totalData = self.state.totalData;
			totalData.datasets.push({
				label: 'Gelen İrsaliye Tutarı',
				type: "line",
				backgroundColor: 'rgba(255,99,132,0.2)',
				borderColor: 'rgba(255,99,132,1)',
				borderWidth: 1,
				hoverBackgroundColor: 'rgba(255,99,132,0.4)',
				hoverBorderColor: 'rgba(255,99,132,1)',
				data: inboxConsumes
			});
			self.setState({despatchInboxCount: responseObject.despatchInboxCount, totalData});
		} else if (type === "despatchOutbox") {
			let outboxConsumes = [0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00];
			let tOutboxConsumes = responseObject.despatchOutboxConsumes;
			for (let i = 0; i < tOutboxConsumes.length; i++) {
				outboxConsumes[tOutboxConsumes[i][1] - 1] = tOutboxConsumes[i][0];
			}
			let totalData = self.state.totalData;
			totalData.datasets.push({
				label: 'Giden İrsaliye Tutarı',
				type: "line",
				backgroundColor: 'rgba(105,231,129,0.2)',
				borderColor: 'rgba(105,231,129,1)',
				borderWidth: 1,
				hoverBackgroundColor: 'rgba(105,231,129,0.4)',
				hoverBorderColor: 'rgba(105,231,129,1)',
				data: outboxConsumes
			});
			self.setState({despatchOutboxCount: responseObject.despatchOutboxCount, totalData});
		} else if (type === "mVoucher") {
			let archiveConsumes = [0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00];
			let tArchiveConsumes = responseObject.mVoucherConsumes;
			for (let i = 0; i < tArchiveConsumes.length; i++) {
				archiveConsumes[tArchiveConsumes[i][1] - 1] = tArchiveConsumes[i][0];
			}
			let totalData = self.state.totalData;
			totalData.datasets.push({
				label: 'Müstahsil Makbuz Tutarı',
				type: "line",
				backgroundColor: 'rgba(239,200,74,0.2)',
				borderColor: 'rgba(239,200,74,1)',
				borderWidth: 1,
				hoverBackgroundColor: 'rgba(239,200,74,0.4)',
				hoverBorderColor: 'rgba(239,200,74,1)',
				data: archiveConsumes
			});
			self.setState({mVoucherCount: responseObject.mVoucherCount, totalData});
		} else if (type === "sVoucher") {
			let archiveConsumes = [0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00];
			let tArchiveConsumes = responseObject.sVoucherConsumes;
			for (let i = 0; i < tArchiveConsumes.length; i++) {
				archiveConsumes[tArchiveConsumes[i][1] - 1] = tArchiveConsumes[i][0];
			}
			let totalData = self.state.totalData;
			totalData.datasets.push({
				label: 'Serbest Meslek Makbuz Tutarı',
				type: "line",
				backgroundColor: 'rgba(239,200,74,0.2)',
				borderColor: 'rgba(239,200,74,1)',
				borderWidth: 1,
				hoverBackgroundColor: 'rgba(239,200,74,0.4)',
				hoverBorderColor: 'rgba(239,200,74,1)',
				data: archiveConsumes
			});
			self.setState({sVoucherCount: responseObject.sVoucherCount, totalData});
		}else if(type === "expenseNote"){
			let archiveConsumes = [0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00];
			let tArchiveConsumes = responseObject.expenseNoteConsumes;
			for (let i = 0; i < tArchiveConsumes.length; i++) {
				archiveConsumes[tArchiveConsumes[i][1] - 1] = tArchiveConsumes[i][0];
			}
			let totalData = self.state.totalData;
			totalData.datasets.push({
				label: 'Gider Pusulası Tutarı',
				type: "line",
				backgroundColor: 'rgba(189,219,255,0.4)',
				borderColor: 'rgba(189,219,255,1)',
				borderWidth: 1,
				hoverBackgroundColor: 'rgba(189,219,255,0.6)',
				hoverBorderColor: 'rgba(189,219,255,1)',
				data: archiveConsumes
			});
			self.setState({expenseNoteCount: responseObject.expenseNoteCount, totalData});
		}else if(type === "exchange"){
			let archiveConsumes = [0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00];
			let tArchiveConsumes = responseObject.exchangeConsumes;
			for (let i = 0; i < tArchiveConsumes.length; i++) {
				archiveConsumes[tArchiveConsumes[i][1] - 1] = tArchiveConsumes[i][0];
			}
			let totalData = self.state.totalData;
			totalData.datasets.push({
				label: 'Döviz Makbuzu Tutarı',
				type: "line",
				backgroundColor: 'rgba(87,163,255,0.4)',
				borderColor: 'rgba(87,163,255,1)',
				borderWidth: 1,
				hoverBackgroundColor: 'rgba(87,163,255,0.6)',
				hoverBorderColor: 'rgba(87,163,255,1)',
				data: archiveConsumes
			});
			self.setState({exchangeCount: responseObject.exchangeCount, totalData});
		} else if (type === "ebelgeSend") {
			let archiveConsumes = [0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00];
			let tArchiveConsumes = responseObject.ebelgeSendConsumes;
			for (let i = 0; i < tArchiveConsumes.length; i++) {
				archiveConsumes[tArchiveConsumes[i][1] - 1] = tArchiveConsumes[i][0];
			}
			let totalData = self.state.totalData;
			totalData.datasets.push({
				label: 'Giden Ebelge Tutarı',
				type: "line",
				backgroundColor: 'rgba(189,219,255,0.4)',
				borderColor: 'rgba(189,219,255,1)',
				borderWidth: 1,
				hoverBackgroundColor: 'rgba(189,219,255,0.6)',
				hoverBorderColor: 'rgba(189,219,255,1)',
				data: archiveConsumes
			});
			self.setState({ebelgeCount: responseObject.ebelgeSendCount, totalData});
		} else if (type === "ebelgeIn") {
			let archiveConsumes = [0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00];
			let tArchiveConsumes = responseObject.ebelgeInboxConsumes;
			for (let i = 0; i < tArchiveConsumes.length; i++) {
				archiveConsumes[tArchiveConsumes[i][1] - 1] = tArchiveConsumes[i][0];
			}
			let totalData = self.state.totalData;
			totalData.datasets.push({
				label: 'Gelen Ebelge Tutarı',
				type: "line",
				backgroundColor: 'rgba(159,245,221,0.4)',
				borderColor: 'rgb(6,245,237)',
				borderWidth: 1,
				hoverBackgroundColor: 'rgba(189,219,255,0.6)',
				hoverBorderColor: 'rgba(189,219,255,1)',
				data: archiveConsumes
			});
			self.setState({ebelgeInCount: responseObject.ebelgeInboxCount, totalData});
		}else if(type === "receipt"){
			let archiveConsumes = [0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00];
			let tArchiveConsumes = responseObject.receiptConsumes;
			for (let i = 0; i < tArchiveConsumes.length; i++) {
				archiveConsumes[tArchiveConsumes[i][1] - 1] = tArchiveConsumes[i][0];
			}
			let totalData = self.state.totalData;
			totalData.datasets.push({
				label: 'Adisyon Makbuzu Tutarı',
				type: "line",
				backgroundColor: 'rgba(87,163,255,0.4)',
				borderColor: 'rgba(87,163,255,1)',
				borderWidth: 1,
				hoverBackgroundColor: 'rgba(87,163,255,0.6)',
				hoverBorderColor: 'rgba(87,163,255,1)',
				data: archiveConsumes
			});
			self.setState({receiptCount: responseObject.receiptCount, totalData});
		}else if(type === "sigorta"){
			let archiveConsumes = [0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00, 0.00];
			let tArchiveConsumes = responseObject.sigortaConsumes;
			for (let i = 0; i < tArchiveConsumes.length; i++) {
				archiveConsumes[tArchiveConsumes[i][1] - 1] = tArchiveConsumes[i][0];
			}
			let totalData = self.state.totalData;
			totalData.datasets.push({
				label: 'Sigorta Makbuzu Tutarı',
				type: "line",
				backgroundColor: 'rgba(87,163,255,0.4)',
				borderColor: 'rgba(87,163,255,1)',
				borderWidth: 1,
				hoverBackgroundColor: 'rgba(87,163,255,0.6)',
				hoverBorderColor: 'rgba(87,163,255,1)',
				data: archiveConsumes
			});
			self.setState({sigortaCount: responseObject.sigortaCount, totalData});
		}  else if (type === "currency") {
			self.setState({
				dollarCurrency: responseObject.dollarCurrency,
				euroCurrency: responseObject.euroCurrency
			});
		} else if (type === "credit") {
			if (!self.isEFatura() && !self.isEArsiv() && !self.isEIrsaliye() && !self.isEMM() && !self.isESMM() && (self.isEDefter() || self.isEDefterSaklama())) {
				let creditInfo = responseObject.creditInfo[0];
				if (creditInfo[1] === 2) {
					self.setState({
						showAlanYukleModal: (showPaytrButton(self.props.currentUser.parentCustomerWorkType, self.state.entegratorConf.identifier)
							&& (self.withCredit() || self.isGarantiBankCustomer())
							&& (!creditInfo[0] || (creditInfo[0] - creditInfo[4] < 0)))
							&& (isContractActive)
					});
				}
			}else if(self.isEFatura() || self.isEArsiv() || self.isEIrsaliye() || self.isEMM() || self.isESMM() ||(!self.isEDefter() || !self.isEDefterSaklama())){
				let creditInfo = responseObject.creditInfo[0];
				let kalanCredit = (new Decimal((creditInfo[0] || 0)).sub(new Decimal((creditInfo[4] || 0))).toNumber());
				if(!self.isEFatura() && !self.isEArsiv() && !self.isEIrsaliye() && !self.isEMM() && !self.isESMM() && (self.isEDefter() || self.isEDefterSaklama())){
					self.setState({
						showKontorYukleModal: (showPaytrButton(self.props.currentUser.parentCustomerWorkType, self.state.entegratorConf.identifier)
							&& (self.withCredit() || self.isGarantiBankCustomer()/*garanti promo-kontör almadan makbuz kesemeyecek*/)
							&& (!creditInfo[0] || (creditInfo[0] - creditInfo[4] < 0)))
					});
				}
				self.setState({
					totalLoadedCredit: creditInfo[0], kalanCredit: kalanCredit,
				} ,() => this.checkKalanBakiye());
			}
		} else if (type === "memory") {
			let memoryInfo = responseObject.memoryInfo[0];
			let kalanMemory = (new Decimal((memoryInfo[0] || 0)).sub(new Decimal((memoryInfo[4] || 0))).toNumber());
			self.setState({
				totalLoadedMemory: memoryInfo[0], kalanMemory: kalanMemory,
				showAlanYukleModal: ((showPaytrButton(self.props.currentUser.parentCustomerWorkType, self.state.entegratorConf.identifier)
					&& (self.withCredit() || self.isGarantiBankCustomer())
					&& (!memoryInfo[0] || (memoryInfo[0] - memoryInfo[4] < 0)))
					&& (self.isEDefter() || self.isEDefterSaklama()))
					&& (isContractActive)
			});
		} else if (type === "fieldCredit") {
			let fieldCreditInfo = responseObject.fieldCreditInfo[0];
			let kalanFieldCredit = (new Decimal((fieldCreditInfo[0] || 0)).sub(new Decimal((fieldCreditInfo[4] || 0))).toNumber());
			self.setState({totalLoadedFieldCredit: fieldCreditInfo[0], kalanFieldCredit: kalanFieldCredit});
		} else {

		}

	}

	withCredit() {
		return this.props.currentUser && this.props.currentUser.withCredit;
	}

	isEczacıKartFatura() {
		return this.props.currentUser && [5925,97359,55151,46486,30735,28839,15829].includes(this.props.currentUser.parentCustomerId);
	}

	isEFatura() {
		return this.props.currentUser && this.props.currentUser.holder.portal && this.props.currentUser.holder.portal.EFATURA;
	}

	isEArsiv() {
		return this.props.currentUser && this.props.currentUser.holder.portal && this.props.currentUser.holder.portal.EARSIV;
	}

	isEczaciKart() {
		return this.props.currentUser && VirtualHost.conf.resourcePrefix === "eczacikart";
	}

	isOgo() {
		return this.props.currentUser && VirtualHost.conf.resourcePrefix === "togb";
	}

	isSmart() {
		return this.props.currentUser && VirtualHost.conf.resourcePrefix === "smart";
	}

	isTdub() {
		return this.props.currentUser && VirtualHost.conf.resourcePrefix === "tdub";
	}

	isMusavir() {
		return this.props.currentUser && VirtualHost.conf.resourcePrefix === "musavir";
	}

	isKolaytest() {
		return this.props.currentUser && VirtualHost.conf.resourcePrefix === "kolaytest";
	}

	isKolaysoft() {
		return this.props.currentUser && VirtualHost.conf.resourcePrefix === "kolaysoft";
	}

	isEsmm() {
		return this.props.currentUser && VirtualHost.conf.resourcePrefix === "esmm";
	}

	isTurcef() {
		return this.props.currentUser && VirtualHost.conf.resourcePrefix === "turcef";
	}

	isMedikal(){
		return this.props.currentUser && VirtualHost.conf.resourcePrefix === "medikal";
	}

	isIsitmeMerkezi(){
		return this.props.currentUser && VirtualHost.conf.resourcePrefix === "isitmemerkezi";
	}

	isTestud(){
		return this.props.currentUser && VirtualHost.conf.resourcePrefix === "testud";
	}

	isUstunBilgisayar(){
		return this.props.currentUser && VirtualHost.conf.resourcePrefix === "ustunbilgisayar";
	}

	isMasfed() {
		return this.props.currentUser && VirtualHost.conf.resourcePrefix === "masfed";
	}

	isTemfed() {
		return this.props.currentUser && VirtualHost.conf.resourcePrefix === "temfed";
	}

	isMbtFatura() {
		return this.props.currentUser && VirtualHost.conf.resourcePrefix === "mbtfatura";
	}

	isEIrsaliye() {
		return this.props.currentUser.holder.portal && this.props.currentUser.holder.portal.EIRSALIYE;
	}

	isEMM() {
		return this.props.currentUser && this.props.currentUser.holder.portal && this.props.currentUser.holder.portal.EMM;
	}

	isExchange() {
		return this.props.currentUser.holder.portal && this.props.currentUser.holder.portal.EEXCHANGE;
	}

	isReceipt() {
		return this.props.currentUser.holder.portal && this.props.currentUser.holder.portal.RECEIPT;
	}

	isESMM() {
		return this.props.currentUser && this.props.currentUser.holder.portal && this.props.currentUser.holder.portal.ESMM;
	}

	isEDefter() {
		return this.props.currentUser && this.props.currentUser.holder.portal && this.props.currentUser.holder.portal.EDEFTER;
	}

	isEDefterSaklama() {
		return this.props.currentUser && this.props.currentUser.holder.portal && this.props.currentUser.holder.portal.EDEFTERSAKLAMA;
	}

	isEDefterIkincilKopya() {
		return this.props.currentUser && this.props.currentUser.holder.portal && this.props.currentUser.holder.portal.EDEFTERIKINCILKOPYA;
	}

	isEGiderPusulasi(){
		return this.props.currentUser && this.props.currentUser.holder.portal && this.props.currentUser.holder.portal.EGIDERPUSULASI;
	}

	isESigorta() {
		return false && this.props.currentUser.holder.portal && this.props.currentUser.holder.portal.ESIGORTA;
	}

	showSGKApppointment(){
		return this.props.currentUser && this.props.currentUser.showSGKApppointment;
	}

	isGarantiBankCustomer() {
		//Garanti sayfasından mı oluşturuldu?
		return this.props.currentUser.parentCustomerId === 11119;
	}

	hasEBelge() {
		return this.props.currentUser && this.props.currentUser.holder.portal && this.props.currentUser.holder.portal.EARSIVBESBINOTUZBIN;
	}

	hasOnlyEBelge() {
		return this.hasEBelge() &&
			!this.isEFatura() &&
			!this.isExchange() &&
			!this.isEArsiv() &&
			!this.isEMM() &&
			!this.isEDefterSaklama() &&
			!this.isEDefter() &&
			!this.isEGiderPusulasi() &&
			!this.isEIrsaliye() &&
			!this.isEDefterIkincilKopya();
	}

	setUserType(){
		if(this.isEFatura() || this.isEArsiv() || this.isEIrsaliye()|| this.isEMM() || this.isESMM()) {
			this.setState({isCreditUser:true});
		}
		if(this.isEDefterSaklama() || this.isEDefter()){
			this.setState({isAreaUser:true});
		}
	}


	onClickDetail(path) {
		this.props.history.push(path)
	}

	showCreditHistory() {
		this.setState({creditHistoryModal: true})
	}

	showPostpaidCustomerList() {
		this.setState({
			postpaidCustomerListModal: true,
		})
	}

	closeCreditHistoryModal() {
		this.setState({
			creditHistoryModal: false,
		})
	}

	closeShowSmmInfoModal() {
		this.setState({
			showSmmInfoModal: false
		})
	}

	closePostpaidCustomerListModal() {
		this.setState({
			postpaidCustomerListModal: false,
		})
	}

	isBaro() {
		let pref = this.props.currentUser && VirtualHost.conf.resourcePrefix;
		return pref === "ankarabarosu" || pref === "hataybarosu" || pref === "afyonbarosu" || pref === "nevsehirbarosu" || pref === "avukat" || pref === "zonguldakbarosu";
	}

	openCallCenterModal() {
		this.setState({
			callCenterModal: true
		})
	}

	handleCloseCallCenterModal() {
		this.setState({
			callCenterModal: false
		})
	}

	openEdefterApplicationModal() {
		this.setState({ edefterApplicationModal: true });
	}

	closeEdefterApplicationModal() {
		this.setState({ edefterApplicationModal: false });
	}

	refreshPage() {
		this.setState({edefterApplicationModal : false}) ;
		window.location.reload();
	}

	openEdefterSecondCopyApplicationModal() {
		this.setState({ edefterSecondCopyApplicationModal: true });
	}

	closeEdefterSecondCopyApplicationModal() {
		this.setState({ edefterSecondCopyApplicationModal: false });
	}

	checkCreditExpire() {
		request({
			url: "/credit/getExpireCredits",
			method: "get"
		}).then(response => {
			if (response && response.data){
				this.setState({creditExpireList: response.data, showCreditExpireModal: response.data.length > 0},() => this.checkCreditExpiration(response.data));
			}

		}).catch(error => {
			console.log(error);
		});
	}
	checkExpireDateControl() {
		request({
			url: "/connector/getExpireDate",
			method: "get"
		}).then(response => {
			if (response && response.data){
				this.setState({expireDate: response.data[0].expireDate,creditExpireList: response.data, showExpireDateModal: response.data.length > 0},() => this.checkExpireDate(response.data));
			}

		}).catch(error => {
			console.log(error);
		});
	}

	modifyDate(date) {
		return moment(date).format('DD-MM-YYYY HH:mm:ss');
	}

	informationMailChange(info){
		let self = this;
		self.props.currentUser.informationMail = info;
		self.setState({
			informationMailCheck: false,
		});
	}

	setSelectYear(value){
		let self = this;
		let totalData = self.state.totalData;
		totalData.datasets=[];
		self.setState({thisYear:value,totalData },()=> this.startInitial());
	}

	handleSelectChange(field, value) {
		this.setState(prevState => {
			const updatedState = {
				[field]: value,
				totalData: {
					...prevState.totalData,
					datasets: []
				}
			};
			const newState = { ...prevState, ...updatedState };
			return updatedState;
		}, () => {
			if (this.state.thisYear && this.state.selectedCurrencyCode) {
				this.startInitial();
			}
		});
	}

	checkDeniedInboxWithError(){
		let self = this;
		let searchQuery = '' ;
		let formData = new FormData();
		formData.append("source", self.state.source);

		let params = {
			url: '/outboxDenied/fetch?page=' + "0" + '&size=' + "10" + " " + searchQuery,
			method: "post",
			data:  formData
		};

		request(params)
			.then(function (response) {
				if(response.data && response.data.content && response.data.content.length > 0)
					self.setState({
						outboxDeniedPage: 0,
						outboxDeniedSize: 10,
						outboxDeniedTotal: response.data.totalElements,
						outboxDeniedContent: response.data.content,
						showDeniedInboxWithError: true
					});
			}).catch(function (error) {
			self.setState({loading: false,searching: false});
			showAxiosError(error);
		});
	}

	confirmSelcukEczaCampaign() {
		if (this.state.selcukEczacampaignSelection === "") {
			Alert.error("Kampanya seçimi boş bırakılamaz.", {
				position: 'top-right',
				effect: 'stackslide',
				timeout: 5000,
				html:false
			});
		} else {
			let self = this;
			let params = {
				url: "/selcukeczacampaign/confirmSelcukCampaign",
				method: "post",
				data: self.state.selcukEczacampaignSelection
			};
			request(params).then(function (igrenoed) {
				self.setState({selcukEczaCampaignModal: false});
				Alert.success("Kampanya seçiminiz yapılmıştır.", {
					position: 'top-right',
					effect: 'stackslide',
					timeout: 5000,
					html:false
				});
			}).catch(function (exception) {
				showAxiosError(exception);
			});
		}
	}

	getEczaciPosToken = async () => {
		let self = this;
		if(self.state.entegratorConf && self.state.entegratorConf.eczaciPosUsername && self.state.entegratorConf.eczaciPosPassword) {
			try {

				const loginRequest = {
					usernameOrEmail: self.state.entegratorConf.eczaciPosUsername,
					password: self.state.entegratorConf.eczaciPosPassword
				};

				const tokenResponse = await request({
					url: self.state.entegratorConf.eczaciPosAuthUrl,
					method: "post",
					data: loginRequest
				});

				if (tokenResponse.data && tokenResponse.data.accessToken) {
					return tokenResponse.data.accessToken;
				} else {
					console.error("Token alınamadı:", tokenResponse.data);
					return null;
				}
			} catch (error) {
				console.error("Hata oluştu:", error);
				return null;
			}
		}
	};

	approvedPosCheck = async () => {
		let { posApprovedCheckSelection } = this.state;
		let vukApplicationNo = this.state.vukApplicationList.filter(f => f.sponsorName === "TEB")[0]?.vukApplicationNo;
		let url = "https://crm.kolaysoft.com.tr/api";

		if (!vukApplicationNo) {
			console.error("VUK Application No bulunamadı!");
			return;
		}

		try {
			const accessToken = await this.getEczaciPosToken();
			if (!accessToken) {
				console.error("ACCESS_TOKEN alınamadı veya null!");
				return;
			}

			if (posApprovedCheckSelection === "true") {
				requestOut({
					url: `${url}/vuk/set-teb-application-completed?vukApplicationNo=${vukApplicationNo}&currentUser=${this.props.currentUser.username}`,
					method: "post",
					headers: {
						Authorization: `Bearer ${accessToken}`,
						"Content-Type": "application/json;charset=UTF-8"
					}
				})
					.then((response) => {
						Alert.success("Yanıtınız Başarıyla Alınmıştır.", {
							position: "top-right",
							effect: "stackslide",
							timeout: 5000
						});
					})
					.catch((error) => {
						showAxiosError(error);
					});
			} else {
				Alert.success("Yanıtınız Başarıyla Alınmıştır.", {
					position: "top-right",
					effect: "stackslide",
					timeout: 5000
				});
			}

			this.setState({ posApprovedModal: false });
		} catch (error) {
			console.error("Hata oluştu:", error);
		}
	};

	checkPendingServiceFee = async () => {
		let self = this;
		const currentUser = this.props.currentUser;
		const url = self.state.entegratorConf.eczaciPosAnnualPaymentUrl;

		if (!currentUser || !currentUser.vknTckn) {
			console.error("VKN/TCKN bilgisi bulunamadı!");
			return;
		}

		try {
			const accessToken = await this.getEczaciPosToken();
			if (!accessToken) {
				console.error("ACCESS_TOKEN alınamadı veya null!");
				return;
			}

			requestOut({
				url: `${url}?identity=${currentUser.vknTckn}`,
				method: "get",
				headers: {
					Authorization: `Bearer ${accessToken}`,
					"Content-Type": "application/json;charset=UTF-8"
				}
			}).then((response) => {
				const data = response.data;
				if (data.paymentUrl) {
					this.setState({
						eczaciposPaymentInfo: data,
						showServiceFeeModal: true
					});
				} else {
					console.log("Ödeme yapılmış.");
				}
			}).catch((error) => {
					console.error("Hata oluştu:", error);
			});
		} catch (error) {
			console.error("Hata oluştu:", error);
		}
	};

	redirectToPayment = () => {
		const { eczaciposPaymentInfo } = this.state;
		if (eczaciposPaymentInfo.paymentUrl) {
			window.location.href = eczaciposPaymentInfo.paymentUrl;
		} else {
			console.error("paymentUrl boş veya geçersiz!");
		}
	}

	checkSelcukCampaign() {
		let self = this;
		let params = {
			url: "/selcukeczacampaign/checkCustomerIsInSelcukEczaList",
			method: "post",
			data: self.props.currentUser.vknTckn
		};

		request(params).then(function (response) {
			self.setState({selcukEczaCampaignModal: response.data});
		}).catch(function (exception) {
			showAxiosError(exception)
		})
	}

	mikrokomHashBuyKontor() {
		let self = this;
		let params = {
			url: "/payTrOrder/hashBuyKontor",
			method: "post",
			data: self.props.currentUser.vknTckn
		};
		request(params).then(( response ) => {
			window.open('https://odeme.mikrokom.com/kontor-yukle/' + response.data,'_blank').focus();
		}).catch((err) => {
			showAxiosError(err)
		})
	}

	disableCardButton() {
		return [EntegratorIdentifiers.MBT, EntegratorIdentifiers.SMART, EntegratorIdentifiers.KOLAYSOFT].includes(this.state.entegratorConf.identifier) &&
			(this.props.impersonateUserRoleId === 3 || this.props.impersonateUserRoleId === 4);
	}

	checkVuk507ButtonShow = () => {
		let self = this;
		let params = {
			url: "/vuk507/seminar/existsCity",
			method: "get",
		};

		request(params).then((response) => {
			if (response && response.data && response.data === true) {
				self.checkVuk507ApplicationStatus();
				self.setState({
					showVuk507PosButton: response && response.data && response.data === true
				});
			}
		}).catch((error) => {
			showAxiosError(error)
		});
	}

	checkVuk507ApplicationStatus = () => {
		let self = this;
		if (self.state.entegratorConf && self.state.entegratorConf.vuk507PosQueryUrl) {
			let hasVukApplication = false;
			let vukApplicationState = self.state.vukApplicationState;
			let vukApplicationTrackingNumber, vukApplicationSponsorName, vukApplicationTrackingStatus = undefined;
			let vukApplicationShowBankDocumentArrivedChose = false;

			requestOut({
				url: self.state.entegratorConf.vuk507PosQueryUrl,
				method: "post",
				data: {
					integrator: "KOLAYSOFT",
					accessKey: localStorage.getItem(ACCESS_TOKEN)
				}
			}).then((response) => {
				if (response && response.data) {
					const data = response.data;
					if (data.length > 0) {
						self.setState({vukApplicationList: data, hasVukApplication: true})
						vukApplicationState = data[0].state;
						hasVukApplication = true;

						if (data[0].trackingNumber) {
							vukApplicationTrackingNumber = data[0].trackingNumber;
						}

						if (data[0].sponsorName) {
							vukApplicationSponsorName = data[0].sponsorName;
						}

						if (data[0].applicationTrackingStatus) {
							vukApplicationTrackingStatus = data[0].applicationTrackingStatus;
						}

						if (data[0].showBankDocumentArrivedChose === true) {
							vukApplicationShowBankDocumentArrivedChose = true;
						}

						let devreyeAlList = data.filter(function (item) {
							return (item.applicationTrackingStatus ==="KARGODA" ||
								item.applicationTrackingStatus ==="RANDEVUSUZ_KURULUM" ||
								item.applicationTrackingStatus ==="RANDEVULU_KURULUM");
						});
						self.setState({devreyeAl: devreyeAlList.length > 0});

						let withoutAppointmentList = data.filter(function (item) {
							return (item.applicationTrackingStatus ==="KARGODA" || item.applicationTrackingStatus === "RANDEVUSUZ_KURULUM");
						});

						let mandatoryList = data.filter(function (item) {
							return (item.applicationTrackingStatus === "RANDEVUSUZ_KURULUM");
						});

						self.setState({withoutAppointment: withoutAppointmentList.length > 0});
						if (withoutAppointmentList.length > 0)
							self.checkAppointment(mandatoryList.length > 0);

						let vukApprovedModal = data.some((app) => {
							return app.sponsorName === "TEB" && app.applicationTrackingStatus === "KURULUM_TAMAMLANDI";
						});

						self.setState({
							hasVukApplication: hasVukApplication,
							vukApplicationState: vukApplicationState,
							vukApplicationTrackingNumber: vukApplicationTrackingNumber,
							vukApplicationSponsorName: vukApplicationSponsorName,
							vukApplicationTrackingStatus: vukApplicationTrackingStatus,
							vukApplicationShowBankDocumentArrivedChose: vukApplicationShowBankDocumentArrivedChose,
							posApprovedModal: vukApprovedModal
						});
						self.checkPendingServiceFee();
					} else {
						console.log(data.errorMessage);
					}
				}
			}).catch((ex) => {
				console.log(ex);
			});
		}
	}


	checkAppointment(mandatory){
		let self = this;
		let params = {
			url: `/sgkappointment/showAppointment`,
			method: "post",
			data:{
				customerId: self.props.currentUser.customerId,
				month: self.state.appointmentMonth
			}
		};
		request(params)
		.then(function (response) {
			self.setState({
				sgkAppointmentModal:  response.data && mandatory,
				mandatoryAppointment: response.data && mandatory
			});
			if(response.data && mandatory){
				self.setState({hasAppointmentModal:false});
			}
		}).catch(function (error) {
			showAxiosError(error);
		});
	}

	checkChemistInformationModalShow = () => {
		let self = this;
		let params = {
			url: "/chemist-information/check",
			method: "get",
		};

		request(params).then((response) => {
			self.setState({showChemistInformationModal: response && response.data && response.data === true});
		}).catch((error) => {
			showAxiosError(error)
		});
	}

	checkNeedBekKvkkSign = () => {
		let self = this;
		let params = {
			url: "/bek-kvkk/checkNeedBekKvkkSign",
			method: "get",
		};

		request(params).then((response) => {
			self.setState({showBekKvkkModal: response && response.data && response.data === true});
		}).catch((error) => {
			showAxiosError(error)
		});
	}

	checkEczaciCepTel = () => {
		let self = this;
		let params = {
			url: "/customer/checkCepTel",
			method: "get",
		};
		request(params).then((response) => {
			if(response.data !== false){
				self.setState({changeCepTelModal : true, customerSorumluCepTel: response.data});
			}
		}).catch((error) => {
			showAxiosError(error)
		});
	}

	vuk507ButtonClick = (sponsor) => {
		let url = this.state.entegratorConf.vuk507PosApplicationUrl;
		if (sponsor) {
			url += "/" + sponsor;
		}
		window.open(url.replace("[token]", localStorage.getItem(ACCESS_TOKEN)), "_blank");
	}

	getVukApplicationStatusText = () => {
		let status, shortStatus = "";
		const {vukApplicationState, vukApplicationTrackingStatus, vukApplicationShowBankDocumentArrivedChose} = this.state;

		if (VukApplicationState.AUTOMATION_SELECTION === vukApplicationState) {
			status = " aşamasındadır.";
			shortStatus = showKolaysoftPos(this.props.currentUser.parentCustomerId, this.state.entegratorConf.vuk507PosApplicationUrl) ? "SEKTÖR SEÇİMİ" :"ECZANE OTOMASYON SEÇİM";
		} else if (VukApplicationState.SPONSOR_SELECTION === vukApplicationState) {
			status = " aşamasındadır.";
			shortStatus = "SPONSOR SEÇİM";
		} else if (VukApplicationState.PAYMENT === vukApplicationState) {
			status = " aşamasındadır.";
			shortStatus = "ÖDEME";
		} else if (VukApplicationState.BANK_CONFIRMATION === vukApplicationState) {
			status = " aşamasındadır.";
			shortStatus = "BANKA ONAYI";
		} else if (VukApplicationState.GIB_ACTIVATION === vukApplicationState) {
			status = " aşamasındadır.";
			shortStatus = "GİB AKTİVASYON";
		} else if ([VukApplicationState.WAITING_GIB_APPROVE_DOCUMENT, VukApplicationState.SIPAY].includes(vukApplicationState)) {
			status = " aşamasındadır.";
			shortStatus = "BELGE YÜKLEME";
		} else if ((VukApplicationState.COMPLETED === vukApplicationState) ||
			([VukApplicationState.PAVO_ACTIVATION, VukApplicationState.VUK_PORTAL_ACTIVATION, VukApplicationState.COMPLETED].includes(vukApplicationState) && VukApplicationTrackingStatus.SON === vukApplicationTrackingStatus)) {
			status = "";
			shortStatus = "TAMAMLANMIŞTIR.";
		} else if (VukApplicationTrackingStatus.IPTAL === vukApplicationTrackingStatus) {
			status = " edilmiştir.";
			shortStatus = "İPTAL";
		} else if ([VukApplicationState.PAVO_ACTIVATION, VukApplicationState.VUK_PORTAL_ACTIVATION].includes(vukApplicationState) &&
			[VukApplicationTrackingStatus.PAVO_AC, VukApplicationTrackingStatus.EVRAK_CIHAZ_YUKLE, VukApplicationTrackingStatus.PAVO_ONAY_BEKLIYOR, VukApplicationTrackingStatus.PAVO_ONAYLADI, VukApplicationTrackingStatus.KARGOYA_VERILECEK, VukApplicationTrackingStatus.ECZACI_POS_AC, VukApplicationTrackingStatus.MAIL_EDONUSUM_AC].includes(vukApplicationTrackingStatus)) {
			status = " aşamasındadır.";
			shortStatus = "KARGO HAZIRLAMA";
		} else if ([VukApplicationState.PAVO_ACTIVATION, VukApplicationState.VUK_PORTAL_ACTIVATION].includes(vukApplicationState) &&
			[VukApplicationTrackingStatus.RANDEVULU_KURULUM,VukApplicationTrackingStatus.RANDEVUSUZ_KURULUM, VukApplicationTrackingStatus.OTOMASYON_ENTEGRASYONU_BEKLENIYOR].includes(vukApplicationTrackingStatus)) {
			status = " aşamasındadır."
			shortStatus = "KURULUM/DEVREYE ALMA";
		} else if (VukApplicationTrackingStatus.BKM_ONAY_BEKLIYOR === vukApplicationTrackingStatus) {
			status = " aşamasındadır.";
			shortStatus = "BKM ONAY";
		} else if (vukApplicationShowBankDocumentArrivedChose && VukApplicationTrackingStatus.BANKA_BASVURUSU_BEKLIYOR === vukApplicationTrackingStatus) {
			status = " aşamasındadır.";
			shortStatus = "BANKA EVRAK TESLİM";
		} else if (VukApplicationState.DELIVERY_PROCESS === vukApplicationState || VukApplicationTrackingStatus.KARGODA === vukApplicationTrackingStatus) {
			status = " aşamasındadır.";
			shortStatus = "KARGO";
		}

		return (
			<p style={{
				fontSize: '14px',
				fontFamily: 'Helvetica Neue, Helvetica, Arial, sans-serif',
				fontWeight: 'bold',
				textAlign: 'center',
				marginBottom: '0'
			}}>{showKolaysoftPos(this.props.currentUser.parentCustomerId, this.state.entegratorConf.vuk507PosApplicationUrl) ? "KolaysoftPos" : "EczacıPos"} başvurunuz&nbsp;
				<a style={{
					color: "#f96332",
					textDecoration: "underline",
					cursor: "pointer",
					target: "_blank",
					fontSize: '18px',

				}}
				   onClick={() => this.vuk507ButtonClick(undefined)}>
					{shortStatus}
				</a>
				{status}
			</p>
		);
	}

	checkShowEczaciposSponsorCards = () => {
		let self = this;
		return self.isEFatura() &&
			self.isEArsiv() &&
			(self.state.showVuk507PosButton || self.state.hasVukApplication) &&
			self.props.currentUser.adminUser &&
			self.isEczaciKart() &&
			self.state.entegratorConf.vuk507PosApplicationUrl;
	}

	setVukApplicationStatus = (vukApplicationState, vukApplicationTrackingStatus) => {
		let self = this;
		const vukApplicationShowBankDocumentArrivedChose = self.state.vukApplicationShowBankDocumentArrivedChose;
		let status = "";
		if (VukApplicationState.AUTOMATION_SELECTION === vukApplicationState) {
			status = showKolaysoftPos(this.props.currentUser.parentCustomerId, this.state.entegratorConf.vuk507PosApplicationUrl) ? "SEKTÖR SEÇİMİ" :"ECZANE OTOMASYON SEÇİM";
		} else if (VukApplicationState.SPONSOR_SELECTION === vukApplicationState) {
			status = "SPONSOR SEÇİM";
		} else if (VukApplicationState.PAYMENT === vukApplicationState) {
			status = "ÖDEME";
		} else if (VukApplicationState.BANK_CONFIRMATION === vukApplicationState) {
			status = "BANKA ONAYI";
		} else if (VukApplicationState.GIB_ACTIVATION === vukApplicationState) {
			status = "GİB AKTİVASYON";
		} else if ([VukApplicationState.WAITING_GIB_APPROVE_DOCUMENT, VukApplicationState.SIPAY].includes(vukApplicationState)) {
			status = "BELGE YÜKLEME";
		} else if ((VukApplicationState.COMPLETED === vukApplicationState) ||
			([VukApplicationState.PAVO_ACTIVATION, VukApplicationState.VUK_PORTAL_ACTIVATION, VukApplicationState.COMPLETED].includes(vukApplicationState) && VukApplicationTrackingStatus.SON === vukApplicationTrackingStatus)) {
			status = "TAMAMLANMIŞTIR.";
		} else if (VukApplicationTrackingStatus.IPTAL === vukApplicationTrackingStatus) {
			status = "İPTAL";
		} else if ([VukApplicationState.PAVO_ACTIVATION, VukApplicationState.VUK_PORTAL_ACTIVATION].includes(vukApplicationState) &&
			[VukApplicationTrackingStatus.PAVO_AC, VukApplicationTrackingStatus.EVRAK_CIHAZ_YUKLE, VukApplicationTrackingStatus.PAVO_ONAY_BEKLIYOR, VukApplicationTrackingStatus.PAVO_ONAYLADI, VukApplicationTrackingStatus.KARGOYA_VERILECEK, VukApplicationTrackingStatus.ECZACI_POS_AC, VukApplicationTrackingStatus.MAIL_EDONUSUM_AC].includes(vukApplicationTrackingStatus)) {
			status = "KARGO HAZIRLAMA";
		} else if ([VukApplicationState.PAVO_ACTIVATION, VukApplicationState.VUK_PORTAL_ACTIVATION].includes(vukApplicationState) &&
			[VukApplicationTrackingStatus.RANDEVULU_KURULUM,VukApplicationTrackingStatus.RANDEVUSUZ_KURULUM, VukApplicationTrackingStatus.OTOMASYON_ENTEGRASYONU_BEKLENIYOR].includes(vukApplicationTrackingStatus)) {
			status = "KURULUM/DEVREYE ALMA";
		} else if (VukApplicationTrackingStatus.BKM_ONAY_BEKLIYOR === vukApplicationTrackingStatus) {
			status = "BKM ONAY";
		} else if (vukApplicationShowBankDocumentArrivedChose && VukApplicationTrackingStatus.BANKA_BASVURUSU_BEKLIYOR === vukApplicationTrackingStatus) {
			status = "BANKA EVRAK TESLİM";
		} else if (VukApplicationState.DELIVERY_PROCESS === vukApplicationState || VukApplicationTrackingStatus.KARGODA === vukApplicationTrackingStatus) {
			status = "KARGO";
		}

		return status;
	}

	renderVukApplicationInfo = () => {
		let self = this;
		const vukApplicationList = self.state.vukApplicationList;
		return vukApplicationList.map((vukApplication) => (
					<div className="">
						<div className="col-md-12 col-container"
							 style={{float: 'left', marginBottom: '5px'}}>
							<div className="col-sm-3">
								<label style={{fontSize: '13px', marginBottom: '5px'}}>
									Sponsor Adı: {vukApplication.sponsorName ? vukApplication.sponsorName : "-"}
								</label>
							</div>
							<div className="col-sm-3 ">
								<label style={{fontSize: '13px', marginBottom: '5px'}}>
									Durumu: {self.setVukApplicationStatus(vukApplication.state, vukApplication.applicationTrackingStatus)}
								</label>
							</div>
							<div className="col-sm-3 ">
								<label style={{fontSize: '13px', marginBottom: '5px'}}>
									Cihaz Adedi: {vukApplication.deviceCount ? vukApplication.deviceCount : "-"}
								</label>
							</div>
							<div className="col-sm-3">
								<button className="TekBtn detay genislik"
										onClick={(e) => this.openVukApplication(vukApplication.vukApplicationNo)}>
									Başvuruya Git
								</button>
							</div>
						</div>
						<div className="col-sm-12 col">
							<hr style={{marginBottom: '15px', marginTop: '5px',  width: "100%"}}></hr>
						</div>
					</div>
		));
	}

	openVukApplication(vukApplicationNo) {
		let self = this;
		let url = this.state.entegratorConf.vuk507PosApplicationUrl;
		if (vukApplicationNo) {
			url += "/" + vukApplicationNo;
		}
		window.open(url.replace("[token]", localStorage.getItem(ACCESS_TOKEN)), "_blank");
	}

	additionalDeviceApplication() {
		let url = this.state.entegratorConf.vuk507AdditionalApplicationUrl;
		window.open(url.replace("[token]", localStorage.getItem(ACCESS_TOKEN)), "_blank");

	}

	customerHasAppointment() {
		let recordId = this.props.currentUser.customerId;

		let params = {
			url: '/sgkappointment/checkCustomerAppointment/' + recordId,
			method: "post",
		};

		request(params)
			.then((response) => {
				let hasAppointment = response.data;
				this.setState({hasAppointment});

				if (!hasAppointment) {
					this.setState({hasAppointmentModal: true});
				}
			})
			.catch((error) => {
				console.error('Error', error);
			});
	}

	fetchTimeline() {
		let params = {
			url: '/timeline/fetchTimelineEntegratorConf',
			method: "post",
		};

		request(params)
			.then((response) => {
				let timelineList = response.data.content;
				const today = new Date();
				today.setHours(0, 0, 0, 0);

				let upcomingTimelines = timelineList.filter(item => {
					let showAtDate = new Date(item.showAt);
					showAtDate.setHours(0, 0, 0, 0);

					return showAtDate.getTime() === today.getTime();
				});

				if (upcomingTimelines.length > 0) {
					this.setState({
						timelineList, selectedTimelines: upcomingTimelines,
					}, () => {
						upcomingTimelines.forEach(timeline => this.openModal(timeline));
					});
				} else {
					console.log("Bugüne ait gösterilecek kayıt bulunamadı.");
				}
			})
			.catch((error) => {
				console.error('Error', error);
			});
	}

	openModal(timeline) {
		const userId = this.props.currentUserId;

		request({
			url: '/timeline/checkUserHasSeen',
			method: 'post',
			data: {timelineId: timeline.recordId, userId: userId}
		})
			.then(response => {
				if (!response.data.hasSeen) {
					this.setState({
						showTimeline: true,
						selectedTimeline: timeline
					});
				}
			})
			.catch(error => {
				console.error("Hata oluştu: ", error);
			});
	}

	handleCloseModal() {
		const {selectedTimeline} = this.state;

		if (selectedTimeline) {
			const userId = this.props.currentUserId;

			request({
				url: '/timeline/markAsSeen',
				method: 'post',
				data: {timelineId: selectedTimeline.recordId, userId: userId}
			})
				.then(() => {
					this.setState({showTimeline: false}, () => {
						this.fetchTimeline();
					});
				})
				.catch(error => {
					console.error("Hata oluştu: ", error);
				});
		}
	}

	render() {
		let {isMobile} = this.state;
		let {vukApplicationList} = this.state;
		const parentCustomerId = localStorage.getItem("parentCustomerId");
		const imageMap = {
			104088: process.env.REACT_APP_CONTEXT_NAME + "/image/kolaysoft-pos-1.png",
			12359: process.env.REACT_APP_CONTEXT_NAME + "/image/isitmepos.png",
			10941: process.env.REACT_APP_CONTEXT_NAME + "/image/medikalpos.png",
			6951: process.env.REACT_APP_CONTEXT_NAME + "/image/optikpos.png",
		};
		const imageSrc = imageMap[parentCustomerId] || process.env.REACT_APP_CONTEXT_NAME + "/image/kolaysoft-pos-1.png";
		const { showServiceFeeModal } = this.state;

		return !this.props.isAuthenticated ?
            <div></div> :
            (
                <div className="row card-stats card-raised" style={{paddingTop: "22px",marginRight: isMobile ? '-44px' : ''}}>
					<div className='pb-1' style={{margin: isMobile ? '0px 20px 0px 0px' : '' }}>
                        <p id='dashboardInfo'><span>*</span> Ana sayfada gösterilen veriler düne ({this.state.day + '.' + this.state.month + '.' + this.state.y}) ait verilerdir. Gün sonunda güncellenecektir.</p>
                    </div>
                    <div className="col-sm-12 row">
						{((this.isEczaciKart() || showKolaysoftPos(this.props.currentUser.parentCustomerId, this.state.entegratorConf.vuk507PosApplicationUrl)) && this.state.devreyeAl) &&
							<div className="col-md-4 col-container">
								<div className="card">
									<div className="col-xs-12" style={{
										display: 'flex',
										flexDirection: 'column',
										alignItems: 'center',
										textAlign: 'center',
										height: '100%',
										justifyContent: 'space-evenly',
										padding: '5px 15px'
									}}>
										<i style={{
											position: 'absolute',
											top: '10px',
											right: '12px',
											fontSize: '20px',
											cursor: 'pointer',
											color: '#ff5757'
										}} className="far fa-question-circle"
										   onClick={() => this.setState({sgkAppointmentModal: true})}/>
										<p style={{
											fontSize: '18px',
											fontFamily: 'Helvetica Neue, Helvetica, Arial, sans-serif',
											fontWeight: 'bold',
											textAlign: 'center',
											marginBottom: '0',
											display: 'inline'
										}}>
											{this.isEczaciKart() ? "EczacıPos" : "KolayPos"} Kurulum Randevusu almak için(Pos cihazınız elinize ulaştıysa) <a
											onClick={() => this.setState({sgkAppointmentModal: true})}>
											<p style={{color: '#f96332', cursor: 'pointer', textDecoration: 'underline'}}>tıklayınız.</p>
										</a>
										</p>
									</div>
								</div>
							</div>
						}

						{(this.checkShowEczaciposSponsorCards() || showKolaysoftPos(this.props.currentUser.parentCustomerId, this.state.entegratorConf.vuk507PosApplicationUrl)) &&
							<div className="col-md-4 col-container"
								 onClick={(event) => (!this.state.vukApplicationTrackingNumber && !this.state.vukApplicationShowBankDocumentArrivedChose ? this.vuk507ButtonClick(undefined) : event.preventDefault())}
								 style={{
									 border: "medium",
									 borderColor: "#f96332",
									 pointerEvents: (this.props.currentUser.impersonate ? "none" : "auto")
								 }}>
								<div className="card">
									{!this.state.hasVukApplication &&
										<div className="col-xs-12" style={{
											display: 'flex',
											flexDirection: 'column',
											alignItems: 'center',
											height: '100%',
											justifyContent: 'space-evenly',
											// padding: '5px 15px',
											// boxShadow: "0px 0px 3px 2px #97bf42",
											borderRadius: "10px"
										}}>
											<Image
												src={imageSrc}
												alt="eczaci-pos-basvuru"/>
										</div>
									}

									{this.state.hasVukApplication &&
										<div className="col-xs-12" style={{
											display: 'flex',
											flexDirection: 'column',
											alignItems: 'center',
											height: '100%',
											justifyContent: 'space-evenly',
											padding: '5px 15px',
											boxShadow: "0px 0px 3px 2px #97bf42",
											borderRadius: "10px"
										}}>
											<div style={{
												width: '100%',
												display: 'flex',
												flexDirection: 'row',
												alignItems: 'center',
												justifyContent: 'space-evenly',
												padding: '0 25px'
											}}>
												<div>
													<Image
														src={process.env.REACT_APP_CONTEXT_NAME + "/image/eczaci-pos-beyaz.png"}
														style={{width: "100px", height: "100px"}} alt="eczaci-pos-beyaz"/>
												</div>
												<label style={{
													fontSize: '20px',
													color: '#f65b5b',
													fontFamily: 'Helvetica Neue, Helvetica, Arial, sans-serif',
													textTransform: 'uppercase',
													fontWeight: "bold"
												}}>{showKolaysoftPos(this.props.currentUser.parentCustomerId, this.state.entegratorConf.vuk507PosApplicationUrl) ? "KolaysoftPos" : "EczacıPos"} Başvurusu</label>
											</div>

											<div style={{
												width: '100%',
												display: 'flex',
												flexDirection: 'row',
												alignItems: 'center',
												justifyContent: 'space-around',
												flexWrap: 'wrap'
											}}>
												{!this.state.hasVukApplication &&
													<p style={{
														fontSize: '14px',
														fontFamily: 'Helvetica Neue, Helvetica, Arial, sans-serif',
														fontWeight: 'bold',
														textAlign: 'center',
														marginBottom: '0'
													}}>{showKolaysoftPos(this.props.currentUser.parentCustomerId, this.state.entegratorConf.vuk507PosApplicationUrl) ? "KolaysoftPos" : "EczacıPos"} başvurunuzu yapmak için&nbsp;
														<a style={{
															color: "#f96332",
															textDecoration: "underline",
															cursor: "pointer",
															target: "_blank",
															fontSize: '18px',

														}}
														   onClick={() => this.vuk507ButtonClick(undefined)}
														>tıklayınız!</a>
													</p>}

												{this.state.hasVukApplication && this.getVukApplicationStatusText()}

												{this.state.hasVukApplication && this.state.vukApplicationTrackingNumber &&
													<p style={{
														fontSize: '14px',
														fontFamily: 'Helvetica Neue, Helvetica, Arial, sans-serif',
														fontWeight: 'bold',
														textAlign: 'center',
														marginBottom: '0'
													}}>Kargo takibine ulaşmak için&nbsp;
														<a style={{
															color: "#f96332",
															textDecoration: "underline",
															cursor: "pointer",
															target: "_blank",
															fontSize: '18px',

														}}
														   onClick={() => window.open("https://www.yurticikargo.com/tr/online-servisler/gonderi-sorgula?code=" + this.state.vukApplicationTrackingNumber, "_blank")}>
															tıklayınız.
														</a>
													</p>
												}

												{this.state.hasVukApplication && this.state.vukApplicationShowBankDocumentArrivedChose &&
													<p style={{
														fontSize: '14px',
														fontFamily: 'Helvetica Neue, Helvetica, Arial, sans-serif',
														fontWeight: 'bold',
														textAlign: 'center',
														marginBottom: '0'
													}}>Bankaya evrağınızı teslim ettiyseniz &nbsp;
														<a style={{
															color: "#f96332",
															textDecoration: "underline",
															cursor: "pointer",
															target: "_blank",
															fontSize: '18px',

														}}
														   onClick={() =>
															   Swal({
																   title: "Evrak Onayı",
																   html: `<div>${(this.state.vukApplicationSponsorName.includes("Şekerbank") ? "Şekerbank'a Eczacıpos Cihaz bildiriminin yapılması için formunuzu teslim ettiniz mi?" :
																	   (this.state.vukApplicationSponsorName.includes("Ziraat")) ? "Ziraat Bankasına Eczacıpos Cihaz bildiriminin yapılması için formunuzu teslim ettiniz mi?" : "Bankanıza Eczacıpos Cihaz bildiriminin yapılması için formunuzu teslim ettiniz mi?")}</div>`,
																   showConfirmButton: true,
																   confirmButtonText: 'Evet',
																   showCancelButton: true,
																   cancelButtonText: 'Hayır',
															   })
																   .then((result) => {
																	   if (result.value) {
																		   requestOut({
																			   url: this.state.entegratorConf.vuk507PosExternalUpdateTrackingStatusUrl,
																			   method: "post",
																			   data: {
																				   integrator: "KOLAYSOFT",
																				   accessKey: localStorage.getItem(ACCESS_TOKEN)
																			   }
																		   }).then((response) => {
																			   if (response && response.data && response.data.result === true) {
																				   this.checkVuk507ApplicationStatus();
																			   } else {
																				   console.log(response && response.data ? response.data.errorMessage : "");
																				   showAxiosError({message: "Evrak teslim durumunuz güncellenemedi. Lütfen daha sonra tekrar deneyiniz"});
																			   }
																		   }).catch((exception) => {
																			   console.log(exception);
																			   showAxiosError({message: "Evrak teslim durumunuz güncellenkirken bir hata ile karşılaşıldı. Lütfen daha sonra tekrar deneyiniz."});
																		   })
																	   } else if (!result.value) {
																		   Swal.close();
																	   }
																   })
														}>
															tıklayınız.
														</a>
													</p>
												}
											</div>
										</div>}
									</div>
							</div>
						}

						{this.checkShowEczaciposSponsorCards() &&
							<div className="col-md-4 col-container"
								 onClick={() => this.vuk507ButtonClick("TURKEKONOMIBANKASI")}
								 style={{
									 border: "medium",
									 borderColor: "#f96332",
									 pointerEvents: (this.props.currentUser.impersonate ? "none" : "auto")
								 }}>
								<div className="card">
									<div className="col-xs-12" style={{
										display: 'flex',
										flexDirection: 'column',
										alignItems: 'center',
										height: '100%',
										justifyContent: 'space-evenly',
										// padding: '5px 15px',
										// boxShadow: "0px 0px 3px 2px #97bf42",
										borderRadius: "10px"
									}}>
										<Image
											src={process.env.REACT_APP_CONTEXT_NAME + "/image/eczacipos-turkekonomibankasi-sponsor.png"}
											alt="eczacipos-turkekonomibankasi-sponsor"/>
									</div>
								</div>
							</div>
						}

						{showKolaysoftPos(this.props.currentUser.parentCustomerId, this.state.entegratorConf.vuk507PosApplicationUrl) &&
							<div className="col-md-4 col-container"
								 onClick={() => this.vuk507ButtonClick("KOLAYSOFT")}
								 style={{
									 border: "medium",
									 borderColor: "#f96332",
									 pointerEvents: (this.props.currentUser.impersonate ? "none" : "auto")
								 }}>
								<div className="card">
									<div className="col-xs-12" style={{
										display: 'flex',
										flexDirection: 'column',
										alignItems: 'center',
										height: '100%',
										justifyContent: 'space-evenly',
										// padding: '5px 15px',
										// boxShadow: "0px 0px 3px 2px #97bf42",
										borderRadius: "10px"
									}}>
										<Image
											src={process.env.REACT_APP_CONTEXT_NAME + "/image/kolaysoft-pos-2.png"}
											alt="eczacipos-kolaysoft-sponsor"/>
									</div>
								</div>
							</div>
						}

						{this.checkShowEczaciposSponsorCards() &&
							<div className="col-md-4 col-container"
								 onClick={() => this.vuk507ButtonClick("KOLAYSOFT")}
								 style={{
									 border: "medium",
									 borderColor: "#f96332",
									 pointerEvents: (this.props.currentUser.impersonate ? "none" : "auto")
								 }}>
								<div className="card">
									<div className="col-xs-12" style={{
										display: 'flex',
										flexDirection: 'column',
										alignItems: 'center',
										height: '100%',
										justifyContent: 'space-evenly',
										// padding: '5px 15px',
										// boxShadow: "0px 0px 3px 2px #97bf42",
										borderRadius: "10px"
									}}>
										<Image
											src={process.env.REACT_APP_CONTEXT_NAME + "/image/eczacipos-kolaysoft-sponsor.png"}
											alt="eczacipos-kolaysoft-sponsor"/>
									</div>
								</div>
							</div>
						}

						{(this.checkShowEczaciposSponsorCards() && (new Date().toJSON().slice(0,10) <= new Date('2024-05-31').toJSON().slice(0,10))) &&
							<div className="col-md-4 col-container"
								 onClick={() => this.vuk507ButtonClick("ZIRAAT")}
								 style={{
									 border: "medium",
									 borderColor: "#f96332",
									 pointerEvents: (this.props.currentUser.impersonate ? "none" : "auto")
								 }}>
								<div className="card">
									<div className="col-xs-12" style={{
										display: 'flex',
										flexDirection: 'column',
										alignItems: 'center',
										height: '100%',
										justifyContent: 'space-evenly',
										// padding: '5px 15px',
										// boxShadow: "0px 0px 3px 2px #97bf42",
									borderRadius: "10px"
									}}>
										<Image
											src={process.env.REACT_APP_CONTEXT_NAME + "/image/eczacipos-ziraatbankasi-sponsor.png"}
											alt="eczacipos-ziraatbankasi-sponsor"/>
									</div>
								</div>
							</div>
						}

						{false && this.checkShowEczaciposSponsorCards() &&
							<div className="col-md-4 col-container"
								 onClick={() => this.vuk507ButtonClick("SEKERBANK")}
								 style={{
									 border: "medium",
									 borderColor: "#f96332",
									 pointerEvents: (this.props.currentUser.impersonate ? "none" : "auto")
								 }}>
								<div className="card">
									<div className="col-xs-12" style={{
										display: 'flex',
										flexDirection: 'column',
										alignItems: 'center',
										height: '100%',
										justifyContent: 'space-evenly',
										// padding: '5px 15px',
										// boxShadow: "0px 0px 3px 2px #97bf42",
										borderRadius: "10px"
									}}>
										<Image
											src={process.env.REACT_APP_CONTEXT_NAME + "/image/eczacipos-sekerbank-sponsor.png"}
											alt="eczacipos-sekerbank-sponsor"/>
									</div>
								</div>
							</div>
						}

                        {(this.isEczaciKart()) &&
                        <div className="col-md-4 col-container">
                            <div className="card">
                                <div className="col-xs-12" style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    textAlign: 'center',
                                    height: '100%',
                                    justifyContent: 'space-evenly',
                                    padding: '5px 15px'
                                }}>
                                    <p style={{
                                        fontSize: '18px',
                                        fontFamily: 'Helvetica Neue, Helvetica, Arial, sans-serif',
                                        fontWeight: 'bold',
                                        textAlign: 'center',
                                        marginBottom: '0',
                                        display: 'inline'
                                    }}>
                                        <a href="https://www.youtube.com/watch?v=6T5xbk-PRRQ" target="_blank">SGK'ya
                                            Nasıl Fatura Kesilir? izlemek için tıklayınız.</a><br/><br/>
                                        <a href="https://www.youtube.com/watch?v=hbXoEjAihsg" target="_blank">Medikal
                                            Market Faturası Nasıl Oluşturulur? izlemek için tıklayınız.</a><br/>
                                    </p>
                                </div>
                            </div>
                        </div>
                        }
                        {(this.isEczaciKart() || this.isTestud()) &&
                        <div className="col-md-4 col-container">
                            <div className="card">
                                <div className="">
                                    <div className=""></div>
                                    <div className="col-md-12">
                                        <Row>
                                            <Col xs="12" style={{textAlign: 'center', padding: '8px'}}>
                                                <Image src={process.env.REACT_APP_CONTEXT_NAME + "/image/goc-logo.png"}
                                                     style={{maxWidth: '35%'}}/>
                                            </Col>
                                        </Row>

										<Row>
											<Col xs="12" style={{textAlign: 'center', padding: '2px'}}>
												<Select name={"year"}
														value={this.state.currentYear}
														clearable={false}
														onChange={e => {
															this.setState({currentYear: e.value});
															this.lastInvoice(e.value,"GOC","nextGocInvoice");
														}}
														options={this.activeYears}/>
												<p style={{fontSize: '15px', color: '#468ae4', margin: '0'}}>Göç
													İdaresi İçin Fatura Numarası</p>
											</Col>
										</Row>

										<Row>
											<Col xs="12" style={{textAlign: 'center'}}>
												<label style={{color: '#d43f00', fontSize: '25px'}}>
													{(this.state.nextGocInvoice) ? this.state.nextGocInvoice : "..."}
												</label>
											</Col>
										</Row>
									</div>
								</div>
							</div>
						</div>
						}
						{(this.isEczaciKart() || this.isIsitmeMerkezi() || this.isMedikal() || this.isTestud()) &&
						<div className="col-md-4 col-container">
							<div className="card">
								<div className="">
									<div className=""></div>
									<div className="col-md-12">
										<Row>
											<Col xs="12" style={{textAlign: 'center', padding: '8px'}}>
												<Image src={process.env.REACT_APP_CONTEXT_NAME + "/image/sgk-logo.png"}
													 style={{maxWidth: '35%'}}/>
											</Col>
										</Row>

										<Row>
											<Col xs="12" style={{textAlign: 'center', padding: '2px'}}>
												<Select name={"year"}
														value={this.state.currentYear}
														clearable={false}
														onChange={e => {
															this.setState({currentYear: e.value});
															this.lastInvoice(e.value,"SGK","lastSgkInvoice");
														}}
														options={this.activeYears}/>
												<p style={{
													fontSize: '15px',
													color: '#468ae4',
													margin: '0'
												}}>Medula {this.isOgo() ? "Optik" : "Eczane"} Döküm Listesi İçin
													Fatura Numarası</p>
											</Col>
										</Row>

										<Row>
											<Col xs="12" style={{textAlign: 'center'}}>
												<label style={{color: '#d43f00', fontSize: '25px'}}>
													{(this.state.lastSgkInvoice) ? this.state.lastSgkInvoice : "..."}
												</label>
											</Col>
										</Row>
									</div>
								</div>
							</div>
						</div>
						}
						{(this.isEczaciKart() || this.isTestud()) &&
							<div className="col-md-4 col-container">
								<div className="card">
									<div className="">
										<div className=""></div>
										<div className="col-md-12">
											<Row>
												<Col xs="12" style={{textAlign: 'center', padding: '2px'}}>
													<Row>
														<Col xs="12" style={{textAlign: 'center'}}>
															<Select name={"year"}
																	value={this.state.currentYear}
																	clearable={false}
																	onChange={e => {
																		this.setState({currentYear: e.value},()=>this.nextInvoicePrefix(this.state.selectedPrefixCode));

																	}}
																	options={this.activeYears}/>
														</Col>
														<Col xs="6" style={{textAlign: 'center'}}>
															<Select name={"prefixCodeType"}
																	value={this.state.selectedPrefixCodeType}
																	clearable={false}
																	placeholder={"Belge Ön Eki Türü Seçiniz"}
																	onChange={(e) => {
																		this.setState({selectedPrefixCodeType: e.value}, () => this.fetchPrefixData());
																	}}
																	options={this.state.prefixCodeTypes}/>
														</Col>
														<Col xs="6" style={{textAlign: 'center'}}>
															<Select name={"prefixCode"}
																	value={this.state.selectedPrefixCode}
																	clearable={false}
																	placeholder={"Belge Ön Eki Seçiniz"}
																	onChange={e => {
																		this.setState({selectedPrefixCode: e.value},() => this.nextInvoicePrefix(e.value));
																	}}
																	options={this.state.prefixCodes}/>
														</Col>
													</Row>
													<p style={{fontSize: '15px', color: '#468ae4', margin: '0'}}>{!!this.state.prefixForDisplay ? this.state.prefixForDisplay + " " : "... "}
														İçin Sıradaki Fatura Numaranız</p>
												</Col>
											</Row>

											<Row>
												<Col xs="12" style={{textAlign: 'center'}}>
													<label style={{color: '#d43f00', fontSize: '25px'}}>
														{(this.state.nextInvoicePrefix) ? this.state.nextInvoicePrefix : "..."}
													</label>
												</Col>
											</Row>
										</div>
									</div>
								</div>
							</div>
						}
						{this.isEFatura() && hasUserRight(UserRightsEnum.invoice.viewIncoming, this.props.currentUser) &&
						<div className=" col-md-4 col-container">
							<div className=" card" style={this.props.decideVakifbankStyle()}>
								<div className="">
									<div className=""></div>
									<div className="col-md-12">
										<div className=" row"
											 style={{paddingTop: '10px', paddingBottom: '20px'}}>
											<div className="col-sm-6">
												<label style={{
													fontSize: '35px', fontWeight: 'bold',
													marginBottom: '0px'
												}}>{(this.state.inboxCount || this.state.inboxCount === 0) ? this.state.inboxCount : "..."}</label>
												<h4 style={{fontFamily: 'Roboto', fontSize: '1em'}}
													className="card-title">
													GELEN FATURALAR</h4>
												<button className="TekBtn detay genislik"
														disabled={this.disableCardButton()}
														onClick={() => this.onClickDetail("/eInvoiceInbox")}>
													Detaylar
												</button>
											</div>
											<div className="col-sm-6">
												<Image className="sag simple-text logo-mini"
													 src={process.env.REACT_APP_CONTEXT_NAME + "/image/inbox2.png"}
													 style={{width: '85px', paddingTop: '20px'}}

												/>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						}
						{this.isEFatura() && hasUserRight(UserRightsEnum.invoice.view, this.props.currentUser) &&
						<div className="col-md-4 col-container">
							<div className="card" style={this.props.decideVakifbankStyle()}>
								<div className="">
									<div className=""></div>
									<div className="col-md-12">
										<div className="row"
											 style={{paddingTop: '10px', paddingBottom: '20px'}}>
											<div className="col-sm-6">
												<label style={{
													fontSize: '35px', fontWeight: 'bold',
													marginBottom: '0px'
												}}>{(this.state.outboxCount || this.state.outboxCount === 0) ? this.state.outboxCount : "..."}</label>
												<h4 style={{fontFamily: 'Roboto', fontSize: '1em'}}
													className="card-title">
													GİDEN FATURALAR</h4>
												<button className="TekBtn detay genislik "
														disabled={this.disableCardButton()}
														onClick={() => this.onClickDetail("/eInvoiceOutbox")}>
													Detaylar
												</button>
											</div>
											<div className="col-sm-6">
												<Image className="sag simple-text logo-mini"
													 src={process.env.REACT_APP_CONTEXT_NAME + "/image/outbox2.png"}
													 style={{width: '85px', paddingTop: '20px'}}

												/>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						}
						{this.isOgo() &&
						<div className="col-md-4 col-container">
							<div className="card">
								<div className="">
									<div className=""></div>
									<div className="col-md-12">
										<Row>
											<Col xs="12" style={{textAlign: 'center', padding: '8px'}}>
												<Image src={process.env.REACT_APP_CONTEXT_NAME + "/image/sgk-logo.png"}
													 style={{maxWidth: '35%'}}/>
											</Col>
										</Row>

										<Row>
											<Col xs="12" style={{textAlign: 'center', padding: '2px'}}>
												<Select name={"year"}
														value={this.state.currentYear}
														clearable={false}
														onChange={e => {
															this.setState({currentYear: e.value});
															this.lastInvoice(e.value,"SGK","lastSgkInvoice");
														}}
														options={this.activeYears}/>
												<p style={{
													fontSize: '15px',
													color: '#468ae4',
													margin: '0'
												}}>Medula {this.isOgo() ? "Optik" : "Eczane"} Döküm Listesi İçin
													Fatura Numarası</p>
											</Col>
										</Row>

										<Row>
											<Col xs="12" style={{textAlign: 'center'}}>
												<label style={{color: '#d43f00', fontSize: '25px'}}>
													{(this.state.lastSgkInvoice) ? this.state.lastSgkInvoice : "..."}
												</label>
											</Col>
										</Row>
									</div>
								</div>
							</div>
						</div>
						}
						{this.isEArsiv() && hasUserRight(UserRightsEnum.earchive.view, this.props.currentUser) &&
						<div className="col-md-4 col-container">
							<div className="card" style={this.props.decideVakifbankStyle()}>
								<div className="">
									<div className=""></div>
									<div className="col-md-12">
										<div className="row"
											 style={{paddingTop: '10px', paddingBottom: '20px'}}>
											<div className="col-sm-6">
												<label style={{
													fontSize: '35px', fontWeight: 'bold',
													marginBottom: '0px'
												}}>{(this.state.archiveCount || this.state.archiveCount === 0) ? this.state.archiveCount : "..."}</label>
												<h4 style={{fontFamily: 'Roboto', fontSize: '1em'}}
													className="card-title">
													e-ARŞİV FATURALAR</h4>
												<button className="TekBtn detay genislik"
														disabled={this.disableCardButton()}
														onClick={() => this.onClickDetail("/eAInvoice")}>
													Detaylar
												</button>
											</div>
											<div className="col-sm-6">
												<Image className=" sag simple-text logo-mini"
													 src={process.env.REACT_APP_CONTEXT_NAME + "/image/archive_count.png"}
													 style={{width: '85px', paddingTop: '20px'}}
												/>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						}
						{this.isEIrsaliye() && hasUserRight(UserRightsEnum.despatch.viewIncoming, this.props.currentUser) &&
						<div className="col-md-4 col-container">
							<div className="card" style={this.props.decideVakifbankStyle()}>
								<div className="">
									<div className=""></div>
									<div className="col-md-12">
										<div className="row"
											 style={{paddingTop: '10px', paddingBottom: '20px'}}>
											<div className="col-sm-6">
												<label style={{
													fontSize: '35px', fontWeight: 'bold',
													marginBottom: '0px'
												}}>{(this.state.despatchInboxCount || this.state.despatchInboxCount === 0) ? this.state.despatchInboxCount : "..."}</label>
												<h4 style={{fontFamily: 'Roboto', fontSize: '1em'}}
													className="card-title">
													GELEN İRSALİYELER</h4>
												<button className="TekBtn detay genislik"
														disabled={this.disableCardButton()}
														onClick={() => this.onClickDetail("/eDespatchInbox")}>
													Detaylar
												</button>
											</div>
											<div className="col-sm-6">
												<Image className=" sag simple-text logo-mini"
													 src={process.env.REACT_APP_CONTEXT_NAME + "/image/inbox2.png"}
													 style={{width: '85px', paddingTop: '20px'}}
												/>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						}
						{this.isEIrsaliye() && hasUserRight(UserRightsEnum.despatch.view, this.props.currentUser) &&
						<div className="col-md-4 col-container">
							<div className="card" style={this.props.decideVakifbankStyle()}>
								<div className="">
									<div className=""></div>
									<div className="col-md-12">
										<div className="row"
											 style={{paddingTop: '10px', paddingBottom: '20px'}}>
											<div className="col-sm-6">
												<label style={{
													fontSize: '35px', fontWeight: 'bold',
													marginBottom: '0px'
												}}>{(this.state.despatchOutboxCount || this.state.despatchOutboxCount === 0) ? this.state.despatchOutboxCount : "..."}</label>
												<h4 style={{fontFamily: 'Roboto', fontSize: '1em'}}
													className="card-title">
													GİDEN İRSALİYELER</h4>
												<button className="TekBtn detay genislik"
														disabled={this.disableCardButton()}
														onClick={() => this.onClickDetail("/eDespatchOutbox")}>
													Detaylar
												</button>
											</div>
											<div className="col-sm-6">
												<Image className=" sag simple-text logo-mini"
													 src={process.env.REACT_APP_CONTEXT_NAME + "/image/outbox2.png"}
													 style={{width: '85px', paddingTop: '20px'}}
												/>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						}
						{this.isEMM() && hasUserRight(UserRightsEnum.voucher.mmView, this.props.currentUser) &&
						<div className="col-md-4 col-container">
							<div className="card" style={this.props.decideVakifbankStyle()}>
								<div className="">
									<div className=""></div>
									<div className="col-md-12">
										<div className="row"
											 style={{paddingTop: '10px', paddingBottom: '20px'}}>
											<div className="col-sm-6">
												<label style={{
													fontSize: '35px', fontWeight: 'bold',
													marginBottom: '0px'
												}}>{(this.state.mVoucherCount || this.state.mVoucherCount === 0) ? this.state.mVoucherCount : "..."}</label>
												<h4 style={{fontFamily: 'Roboto', fontSize: '1em'}}
													className="card-title">
													e-MÜSTAHSİL MAKBUZLAR</h4>
												<button className="TekBtn detay genislik"
														disabled={this.disableCardButton()}
														onClick={() => this.onClickDetail("/eVoucherM")}>
													Detaylar
												</button>
											</div>
											<div className="col-sm-6">
												<Image className="sag simple-text logo-mini"
													 src={process.env.REACT_APP_CONTEXT_NAME + "/image/archive_count.png"}
													 style={{width: '85px', paddingTop: '20px'}}
												/>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						}
						{this.isESMM() && hasUserRight(UserRightsEnum.voucher.smmView, this.props.currentUser) &&
						<div className="col-md-4 col-container">
							<div className="card" style={this.props.decideVakifbankStyle()}>
								<div className="">
									<div className=""></div>
									<div className="col-md-12">
										<div className="row"
											 style={{paddingTop: '10px', paddingBottom: '20px'}}>
											<div className="col-sm-6">
												<label style={{
													fontSize: '35px', fontWeight: 'bold',
													marginBottom: '0px'
												}}>{(this.state.sVoucherCount || this.state.sVoucherCount === 0) ? this.state.sVoucherCount : "..."}</label>
												<h4 style={{fontFamily: 'Roboto', fontSize: '1em'}}
													className="card-title">e-SERBEST MESLEK MAKBUZLAR</h4>
												<button className="TekBtn detay genislik"
														disabled={this.disableCardButton()}
														onClick={() => this.onClickDetail("/eVoucherS")}>
													Detaylar
												</button>
											</div>
											<div className="col-sm-6">
												<Image className=" sag simple-text logo-mini"
													 src={process.env.REACT_APP_CONTEXT_NAME + "/image/archive_count.png"}
													 style={{width: '85px', paddingTop: '20px'}}
												/>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						}
						{this.isEGiderPusulasi() && hasUserRight(UserRightsEnum.newExpenseNote.view,this.props.currentUser) &&
						<div className="col-md-4 col-container">
							<div className="card" style={this.props.decideVakifbankStyle()}>
								<div className="">
									<div className=""></div>
									<div className="col-md-12">
										<div className="row"
											 style={{paddingTop: '10px', paddingBottom: '20px'}}>
											<div className="col-sm-6">
												<label style={{
													fontSize: '35px', fontWeight: 'bold',
													marginBottom: '0px'
												}}>{(this.state.expenseNoteCount || this.state.expenseNoteCount === 0) ? this.state.expenseNoteCount : "..."}</label>
												<h4 style={{fontFamily: 'Roboto', fontSize: '1em'}}
													className="card-title">e-GİDER PUSULASI</h4>
												<button className="TekBtn detay genislik"
														disabled={this.disableCardButton()}
														onClick={() => this.onClickDetail("/newExpenseNote")}>
													Detaylar
												</button>
											</div>
											<div className="col-sm-6">
												<Image className=" sag simple-text logo-mini"
													 src={process.env.REACT_APP_CONTEXT_NAME + "/image/archive_count.png"}
													 style={{width: '85px', paddingTop: '20px'}}
												/>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						}
						{this.isExchange() && hasUserRight(UserRightsEnum.exchange.view, this.props.currentUser) &&
						<div className="col-md-4 col-container">
							<div className="card" style={this.props.decideVakifbankStyle()}>
								<div className="">
									<div className=""></div>
									<div className="col-md-12">
										<div className="row"
											 style={{paddingTop: '10px', paddingBottom: '20px'}}>
											<div className="col-sm-6">
												<label style={{
													fontSize: '35px', fontWeight: 'bold',
													marginBottom: '0px'
												}}>{(this.state.exchangeCount || this.state.exchangeCount === 0) ? this.state.exchangeCount : "..."}</label>
												<h4 style={{fontFamily: 'Roboto', fontSize: '1em'}}
													className="card-title">
													e-DÖVİZ MAKBUZLAR</h4>
												<button className="TekBtn detay genislik"
														disabled={this.disableCardButton()}
														onClick={() => this.onClickDetail("/exchangeList")}>
													Detaylar
												</button>
											</div>
											<div className="col-sm-6">
												<Image className="sag simple-text logo-mini"
													 src={process.env.REACT_APP_CONTEXT_NAME + "/image/archive_count.png"}
													 style={{width: '85px', paddingTop: '20px'}}
												/>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						}
						{this.hasEBelge() &&
						<div className="col-md-4 col-container">
							<div className="card" style={this.props.decideVakifbankStyle()}>
								<div className="">
									<div className=""></div>
									<div className="col-md-12">
										<div className="row"
											 style={{paddingTop: '10px', paddingBottom: '20px'}}>
											<div className="col-sm-6">
												<label style={{
													fontSize: '35px', fontWeight: 'bold',
													marginBottom: '0px'
												}}>{(this.state.ebelgeCount || this.state.ebelgeCount === 0) ? this.state.ebelgeCount : "..."}</label>
												<h4 style={{fontFamily: 'Roboto', fontSize: '1em'}}
													className="card-title">
													GİDEN EBELGELER</h4>
												<button className="TekBtn detay genislik"
														disabled={this.disableCardButton()}
														onClick={() => this.onClickDetail("/belgeSend")}>
													Detaylar
												</button>
											</div>
											<div className="col-sm-6">
												<Image className="sag simple-text logo-mini"
													 src={process.env.REACT_APP_CONTEXT_NAME + "/image/outbox2.png"}
													 style={{width: '85px', paddingTop: '20px'}}
												/>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						}
						{this.hasEBelge() &&
						<div className="col-md-4 col-container">
							<div className="card" style={this.props.decideVakifbankStyle()}>
								<div className="">
									<div className=""></div>
									<div className="col-md-12">
										<div className="row"
											 style={{paddingTop: '10px', paddingBottom: '20px'}}>
											<div className="col-sm-6">
												<label style={{
													fontSize: '35px', fontWeight: 'bold',
													marginBottom: '0px'
												}}>{(this.state.ebelgeInCount || this.state.ebelgeInCount === 0) ? this.state.ebelgeInCount : "..."}</label>
												<h4 style={{fontFamily: 'Roboto', fontSize: '1em'}}
													className="card-title">
													GELEN EBELGELER</h4>
												<button className="TekBtn detay genislik"
														disabled={this.disableCardButton()}
														onClick={() => this.onClickDetail("/belgeIn")}>
													Detaylar
												</button>
											</div>
											<div className="col-sm-6">
												<Image className="sag simple-text logo-mini"
													 src={process.env.REACT_APP_CONTEXT_NAME + "/image/inbox2.png"}
													 style={{width: '85px', paddingTop: '20px'}}
												/>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						}
						{this.isReceipt() && hasUserRight(UserRightsEnum.receipt.view, this.props.currentUser) &&
						<div className="col-md-4 col-container">
							<div className="card" style={this.props.decideVakifbankStyle()}>
								<div className="">
									<div className=""></div>
									<div className="col-md-12">
										<div className="row"
											 style={{paddingTop: '10px', paddingBottom: '20px'}}>
											<div className="col-sm-6">
												<label style={{
													fontSize: '35px', fontWeight: 'bold',
													marginBottom: '0px'
												}}>{(this.state.receiptCount || this.state.receiptCount === 0) ? this.state.receiptCount : "..."}</label>
												<h4 style={{fontFamily: 'Roboto', fontSize: '1em'}}
													className="card-title">
													e-ADİSYON MAKBUZLAR</h4>
												<button className="TekBtn detay genislik"
														disabled={this.disableCardButton()}
														onClick={() => this.onClickDetail("/receiptList")}>
													Detaylar
												</button>
											</div>
											<div className="col-sm-6">
												<Image className="sag simple-text logo-mini"
													 src={process.env.REACT_APP_CONTEXT_NAME + "/image/archive_count.png"}
													 style={{width: '85px', paddingTop: '20px'}}
												/>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						}

						{this.isESigorta() && hasUserRight(UserRightsEnum.sigorta.view, this.props.currentUser) &&
							<div className="col-md-4 col-container">
								<div className="card" style={this.props.decideVakifbankStyle()}>
									<div className="">
										<div className=""></div>
										<div className="col-md-12">
											<div className="row"
												 style={{paddingTop: '10px', paddingBottom: '20px'}}>
												<div className="col-sm-6">
													<label style={{
														fontSize: '35px', fontWeight: 'bold',
														marginBottom: '0px'
													}}>{(this.state.sigortaCount || this.state.sigortaCount === 0) ? this.state.sigortaCount : "..."}</label>
													<h4 style={{fontFamily: 'Roboto', fontSize: '1em'}}
														className="card-title">
														e-SİGORTA MAKBUZLAR</h4>
													<button className="TekBtn detay genislik"
															disabled={this.disableCardButton()}
															onClick={() => this.onClickDetail("/sigortaList")}>
														Detaylar
													</button>
												</div>
												<div className="col-sm-6">
													<Image className="sag simple-text logo-mini"
														   src={process.env.REACT_APP_CONTEXT_NAME + "/image/archive_count.png"}
														   style={{width: '85px', paddingTop: '20px'}}
													/>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						}

						{showContactCard() &&
						<div className="col-md-4 col-container">
							<div className=" card" style={this.props.decideVakifbankStyle()}>
								<div className="col-xs-12" style={{
									display: 'flex',
									flexDirection: 'column',
									alignItems: 'center',
									height: '100%',
									justifyContent: 'space-evenly',
									padding: '5px 15px'
								}}>
									{!this.isUstunBilgisayar() && <i style={{
										position: 'absolute',
										top: '10px',
										right: '12px',
										fontSize: '20px',
										cursor: 'pointer',
										color: '#ff5757'
									}} className="far fa-question-circle"
																	 onClick={() => this.openCallCenterModal()}/>}
									<div style={{
										width: '100%',
										display: 'flex',
										flexDirection: 'row',
										alignItems: 'center',
										justifyContent: 'space-evenly',
										padding: '0 25px'
									}}>
										<div><i style={{fontSize: '30px', color: '#718ecf'}}
												className="fas fa-headphones"/></div>
										<label style={{
											fontSize: '20px',
											color: '#f65b5b',
											fontFamily: 'Helvetica Neue, Helvetica, Arial, sans-serif',
											textTransform: 'uppercase'
										}}>Çağrı Merkezİ</label>
									</div>

									<div style={{
										width: '100%',
										display: 'flex',
										flexDirection: 'row',
										alignItems: 'center',
										justifyContent: 'space-around'
									}}>
										<p style={{
											fontSize: '25px',
											fontFamily: 'Helvetica Neue, Helvetica, Arial, sans-serif',
											fontWeight: 'bold',
											marginBottom: '0'
										}}>
											{this.isBaro() && '0850 259 19 24'}
											{this.isEczaciKart() && '0850 259 98 08'}
											{this.isOgo() && '0850 259 96 06'}
											{this.isSmart() && '0850 259 93 93'}
											{this.isMusavir() && '0850 259 19 89'}
											{this.isUstunBilgisayar() && '0362 435 01 76'}
											{this.isKolaytest() && '0850 456 78 90'}
											{(this.isKolaysoft() || this.isTdub() || this.isEsmm() || this.isTurcef() || this.isMedikal()
												|| this.isIsitmeMerkezi() || this.isTestud() || this.isMasfed() || this.isTemfed()) && '0850 259 90 90'}
											{this.isMbtFatura() && "0 850 308 06 28"}
										</p>
									</div>
									<div style={{
										width: '100%',
										display: 'flex',
										flexDirection: 'row',
										alignItems: 'center',
										justifyContent: 'space-around'
									}}>
										<p style={{
											fontSize: '15px',
											fontFamily: 'Helvetica Neue, Helvetica, Arial, sans-serif',
											fontWeight: 'bold',
											marginBottom: '0',
										}}>
											{this.isBaro() && 'avukatdestek@kolaysoft.com.tr'}
											{this.isEczaciKart() && 'eczacidestek@kolaysoft.com.tr'}
											{this.isOgo() && 'optikdestek@kolaysoft.com.tr '}
											{this.isSmart() && 'destek@smartdonusum.com'}
											{this.isMusavir() && 'musavirdestek@kolaysoft.com.tr'}
											{(this.isMedikal() || this.isIsitmeMerkezi() || this.isTestud()) && 'medikaldestek@kolaysoft.com.tr'}
											{(this.isKolaysoft() || this.isTdub() || this.isEsmm() || this.isTurcef()
												|| this.isTemfed() || this.isMasfed() || this.isKolaytest()) && 'destek@kolaysoft.com.tr'}
											{this.isMbtFatura() && "destek@mbtteknoloji.com.tr\n"}
										</p>
									</div>

									{!this.isUstunBilgisayar() &&
									<div style={{
										width: '100%',
										display: 'flex',
										flexDirection: 'row',
										alignItems: 'center',
										justifyContent: 'space-around'
									}}>
										{!this.isUstunBilgisayar() &&
										<p style={{
											fontSize: '14px',
											fontFamily: 'Helvetica Neue, Helvetica, Arial, sans-serif',
											fontWeight: 'bold',
											textAlign: 'center',
											marginBottom: '0'
										}}>Uzaktan bağlantı programını bilgisayarınıza kurmak için
											<a href='https://download.anydesk.com/AnyDesk.exe'
											   target='_blank'> tıklayınız!
											</a>
										</p>
										}
									</div>
									}
								</div>
							</div>
						</div>
						}
						{(this.checkShowEczaciposSponsorCards() || showKolaysoftPos(this.props.currentUser.parentCustomerId, this.state.entegratorConf.vuk507PosApplicationUrl)) &&
							<div className="col-md-8 col-container">
								<div className="card" style={this.props.decideVakifbankStyle()}>
									<div className="">
										<div className="card-header">
											<h4 className="card-title">{showKolaysoftPos(this.props.currentUser.parentCustomerId, this.state.entegratorConf.vuk507PosApplicationUrl) ? "KolaysoftPos" : "EczacıPos"} Başvuru Bilgileri</h4>
										</div>
										<div className="card-body">
											<div className="row">
												<div className="col-md-12 ">
													{
														this.renderVukApplicationInfo()
													}

												</div>
											</div>

											<div className=" col-sm-12 row"
												 style={{margin: '0 0 0 0', padding: '0 0 0 0'}}>
												<Col sm='4'>
													<StickButton position="leftSide" className="stickButton"
																 label="Ek Cihaz Başvuru"
																 labelClass='homePageLabelClass'
																 onClick={() => this.additionalDeviceApplication()}/>
												</Col>
											</div>
										</div>
									</div>
								</div>
							</div>}
						<div className="col-sm-12 row">

						{this.isEczaciKart() && [28839,30735,15829].includes(this.props.currentUser.parentCustomerId) &&
						<div className="col-md-4 col-container">
							<div className=" card" style={this.props.decideVakifbankStyle()}>
								<div className="col-xs-12" style={{
									display: 'flex',
									flexDirection: 'column',
									alignItems: 'center',
									height: '100%',
									justifyContent: 'space-evenly',
									padding: '5px 15px'
								}}>
									<i style={{
										position: 'absolute',
										top: '10px',
										right: '12px',
										fontSize: '20px',
										cursor: 'pointer',
										color: '#ff5757'
									}} className="far fa-question-circle"
									   onClick={() => this.setState({chemistCampaignModal: true})}/>
									<div style={{
										width: '100%',
										display: 'flex',
										flexDirection: 'row',
										alignItems: 'center',
										justifyContent: 'space-evenly',
										padding: '0 25px'
									}}><br/>
										<div><i style={{fontSize: '30px', color: '#718ecf'}}
												/></div>
										<label style={{
											fontSize: '20px',
											color: '#f65b5b',
											fontFamily: 'Helvetica Neue, Helvetica, Arial, sans-serif',
											textTransform: 'uppercase'
										}}></label>
									</div>
									<div style={{
										width: '100%',
										display: 'flex',
										flexDirection: 'row',
										alignItems: 'center',
										justifyContent: 'space-around'
									}}>
										<p style={{
											fontSize: '18px',
											fontFamily: 'Helvetica Neue, Helvetica, Arial, sans-serif',
											fontWeight: 'bold',
											marginBottom: '0',
											textAlign: 'center'
										}}>
											{this.state.chemistCampaignText}
										</p>
									</div>

									<div style={{
										width: '100%',
										display: 'flex',
										flexDirection: 'row',
										alignItems: 'center',
										justifyContent: 'space-around'
									}}>
										<p style={{
											fontSize: '18px',
											fontFamily: 'Helvetica Neue, Helvetica, Arial, sans-serif',
											fontWeight: 'bold',
											textAlign: 'center',
											marginBottom: '0'
										}}>Kampanya detayına ulaşmak için
											<a onClick={() => this.setState({chemistCampaignModal: true})}>
												<p style={{color: '#f96332', cursor: 'pointer', textDecoration: 'underline'}}>tıklayınız!</p>
											</a>
										</p>
									</div>

								</div>
							</div>
						</div>
						}

						{showEdefterApplicationCard(this.state.entegratorConf.identifier) && this.isEFatura() && !this.isEDefter() &&
						<div className="col-md-4 col-container">
							<div className="card blink" style={this.props.decideVakifbankStyle()}>
								<div className="col-xs-12" style={{
									display: 'flex',
									flexDirection: 'column',
									alignItems: 'center',
									height: '100%',
									justifyContent: 'space-evenly',
									padding: '5px 15px'
								}}>
									<div style={{
										width: '100%',
										display: 'flex',
										flexDirection: 'row',
										alignItems: 'center',
										justifyContent: 'space-evenly',
										padding: '0 25px'
									}}>
										<div><i style={{fontSize: '30px', color: '#718ecf'}}
												className="fas fa-book"/></div>
										<label style={{
											fontSize: '20px',
											color: '#f65b5b',
											fontFamily: 'Helvetica Neue, Helvetica, Arial, sans-serif',
											textTransform: 'uppercase'
										}}>e-Defter Başvurusu</label>
									</div>

									<div style={{
										width: '100%',
										display: 'flex',
										flexDirection: 'row',
										alignItems: 'center',
										justifyContent: 'space-around'
									}}>
										<p style={{
											fontSize: '14px',
											fontFamily: 'Helvetica Neue, Helvetica, Arial, sans-serif',
											fontWeight: 'bold',
											textAlign: 'center',
											marginBottom: '0'
										}}>e-Defter başvurunuzu yapmak için&nbsp;
											<a style={{
												color:"#f96332",
												textDecoration:"none",
												cursor:"pointer" }}
											   onClick={() => this.openEdefterApplicationModal()}>tıklayınız!</a>
										</p>
									</div>
								</div>
							</div>
						</div>
						}

						{showEdefterApplicationCard(this.state.entegratorConf.identifier) && this.isEFatura() && !this.isEDefter() &&
						<div className="col-md-4 col-container">
							<div className="card blink" style={this.props.decideVakifbankStyle()}>
								<div className="col-xs-12" style={{
									display: 'flex',
									flexDirection: 'column',
									alignItems: 'center',
									height: '100%',
									justifyContent: 'space-evenly',
									padding: '5px 15px'
								}}>
									<div style={{
										width: '100%',
										display: 'flex',
										flexDirection: 'row',
										alignItems: 'center',
										justifyContent: 'space-evenly',
										padding: '0 25px'
									}}>
										<div><i style={{fontSize: '30px', color: '#718ecf'}}
												className="fas fa-book"/></div>
										<label style={{
											fontSize: '20px',
											color: '#f65b5b',
											fontFamily: 'Helvetica Neue, Helvetica, Arial, sans-serif',
											textTransform: 'uppercase'
										}}>e-Defter Aktivasyonu</label>
									</div>

									<div style={{
										width: '100%',
										display: 'flex',
										flexDirection: 'row',
										alignItems: 'center',
										justifyContent: 'space-around'
									}}>
										<p style={{
											fontSize: '14px',
											fontFamily: 'Helvetica Neue, Helvetica, Arial, sans-serif',
											fontWeight: 'bold',
											textAlign: 'center',
											marginBottom: '0'
										}}>e-Defter aktivasyonu nasıl yapılır? İzlemek için&nbsp;
											<a style={{
												color:"#f96332",
												textDecoration:"none",
												cursor:"pointer" }}
											   onClick={() => this.setState({showEdefterApplicationVideoModal:true})}>tıklayınız!
											</a>
										</p>
									</div>
								</div>
							</div>
						</div>
						}
					</div>
					<div className="col-sm-12 row">
						{
							((this.isEFatura() && hasUserRight(UserRightsEnum.invoice.view, this.props.currentUser)) ||
								(this.isEArsiv() && hasUserRight(UserRightsEnum.earchive.view, this.props.currentUser)) ||
								(this.isEMM() && hasUserRight(UserRightsEnum.voucher.mmView, this.props.currentUser)) ||
								(this.isExchange() && hasUserRight(UserRightsEnum.exchange.view, this.props.currentUser)) ||
								(this.hasEBelge()) ||
								(this.isESMM() && hasUserRight(UserRightsEnum.voucher.smmView, this.props.currentUser))) &&
							<div className="col-md-8 col-container" style={{marginTop: '20px'}}>
								<div className="card" style={this.props.decideVakifbankStyle()}>
									<div className="">
										<div className="card-header">
											<div className="row">
												<div className="col-6">
													<h4 className="card-title">AYLIK {(this.isEFatura() || this.isEArsiv() || this.hasEBelge()) ? "FATURA" : "MAKBUZ"} TUTARI</h4>
												</div>

												<div className="col-6">
													<div className="row d-flex justify-content-end">
														<div className="col-sm-4">
															<Select
																className="selectpicker"
																type="select"
																value={this.state.thisYear}
																clearable={false}
																noResultsText="Veri yok"
																clearValueText="Temizle"
																placeholder="Seçiniz..."
																onChange={(e) => this.handleSelectChange("thisYear", e.value)}
																options={this.state.optionsYears}
															/>
														</div>
														<div className="col-sm-4">
															<Select
																className="selectpicker"
																type="select"
																value={this.state.selectedCurrencyCode ? this.state.selectedCurrencyCode : {label:"TL", value:"TRY"}}
																clearable={false}
																noResultsText="Veri yok"
																clearValueText="Temizle"
																placeholder="Seçiniz..."
																onChange={(e) => this.handleSelectChange("selectedCurrencyCode", e)}
																options={this.state.optionsCurrencyCode}
															/>
														</div>
													</div>
												</div>

											</div>

										</div>
										<div className="card-body">
											<div className="col-md-12 row">
												<Bar data={this.state.totalData || {labels: []}}
													 width={100}
													 height={isMobile ? 400 : 200}
													 options={{
														 maintainAspectRatio: false,
														 legend: {align:isMobile ? 'start' : 'center'} }}/>
											</div>
										</div>
									</div>
								</div>
							</div>
						}

						{(this.isEFatura() || this.isEArsiv() || this.isEMM() || this.isESMM() || this.isEIrsaliye() ||
								this.isEDefter() || this.isEDefterSaklama || this.isEGiderPusulasi() || this.isExchange() || this.isReceipt() || this.isESigorta()) &&
							<div className="col-md-4 col" style={{marginTop: '20px'}}>
								<div className="card" style={this.props.decideVakifbankStyle()}>
									{isVakifbank() ?
										(<div className="">
											<div className="card-header">
												<h4 className="card-title">&nbsp;&nbsp;</h4>
											</div>
											<div className="card-body" style={{padding: '3px 15px 10px 15px'}}>
												<div className="row">
													<div className="col-md-12 ">
														<p style={{
															fontSize: "27px",
															color: "red",
															textAlign: "center",
															paddingTop: "30px"
														}}>Bakiye Durumunuzu
															<br/> interaktif bankacılıktan <br/>
															kontrol edebilirsiniz.</p>
													</div>
												</div>
											</div>
										</div>) :
										(<div className="">
											<div className="card-header">
												<h4 className="card-title">KALAN BAKİYENİZ</h4>
											</div>
											<div className="card-body" style={{padding: '3px 15px 10px 15px'}}>
												<div className="row">
													<div className="col-md-12 ">
														<div className="col-md-12 row"
															 style={{float: 'left', marginBottom: '5px'}}>
															<div className="col-sm-8">
																<label style={{
																	fontSize: '16px',
																	fontWeight: 'bold',
																}}> Kontör Durumu
																</label>
															</div>
															<div className="col-sm-4"></div>
															<div className="col-sm-12 ">
																<label style={{fontSize: '13px', marginBottom: '5px'}}>Aktif
																	Yük.
																	Kontör: {(this.state.totalLoadedCredit || this.state.totalLoadedCredit === 0) ? (this.state.totalLoadedCredit >= 100000 && show100000AsUnlimited(this.props.currentUser.parentCustomerId) ? "Sınırsız" : this.state.totalLoadedCredit) : "..."}</label>
															</div>
															<div className="col-sm-12 ">
																<label>Kontör Durumu:
																	{
																		(this.state.kalanCredit || this.state.kalanCredit === 0)
																			? (this.state.totalLoadedCredit >= 100000 && show100000AsUnlimited(this.props.currentUser.parentCustomerId)
																				? "Sınırsız"
																				:
																				(showKalanBaro() ? this.state.totalLoadedCredit : this.state.kalanCredit))
																			: "..."
																	}
																</label>
															</div>
														</div>
													</div>
												</div>
												<hr style={{marginBottom: '10px', marginTop: '10px'}}></hr>
												<div className=" row">
													<div className="col-md-12">
														<div className=" col-md-12 row" style={{float: 'left'}}>
															<div className="col-sm-12">
																<label style={{
																	fontSize: '16px',
																	fontWeight: 'bold',
																	whiteSpace: 'nowrap'
																}}> {defterUnitName(EntegratorConf.identifier)} Durumu
																</label>
															</div>
															<div className="col-sm-12 ">
																<label style={{fontSize: '13px', marginBottom: '5px'}}>Aktif
																	Yük.
																	{defterUnitName(EntegratorConf.identifier)}: {(this.state.totalLoadedMemory || this.state.totalLoadedMemory === 0) ? this.state.totalLoadedMemory : "..."}</label>
															</div>
															<div className="col-sm-12 ">
																<label style={{whiteSpace: 'nowrap'}}>{defterUnitName(EntegratorConf.identifier)} Durumu: {(this.state.kalanMemory || this.state.kalanMemory === 0) ? this.state.kalanMemory : "..."}</label>
															</div>
														</div>
													</div>
												</div>

												<hr style={{marginBottom: '10px', marginTop: '10px'}}></hr>


												{(this.isEArsiv() && ['interpos', 'bilnex'].includes(VirtualHost.conf.resourcePrefix)) &&
													<div className=" row">
														<div className="col-md-12">
															<div className=" col-md-12 row" style={{float: 'left'}}>
																<div className="col-sm-12">
																	<label style={{
																		fontSize: '16px',
																		fontWeight: 'bold',
																		whiteSpace: 'nowrap'
																	}}> Arşiv Kasa Kontör Durumu
																	</label>
																</div>


																<div className="col-sm-12 ">
																	<label
																		style={{fontSize: '13px', marginBottom: '5px'}}>Aktif
																		Yük.
																		Arşiv Kasa
																		Kontörü: {(this.state.totalLoadedFieldCredit || this.state.totalLoadedFieldCredit === 0) ? this.state.totalLoadedFieldCredit : "..."}
																	</label>
																</div>
																<div className="col-sm-12">
																	<label style={{whiteSpace: 'nowrap'}}>Arşiv Kasa
																		Kontör
																		Durumu: {(this.state.kalanFieldCredit || this.state.kalanFieldCredit === 0) ? this.state.kalanFieldCredit : "..."}</label>
																</div>


															</div>
														</div>
													</div>}
												{(EntegratorIdentifiers.KOLAYSOFT === this.state.entegratorConf.identifier || EntegratorIdentifiers.SMART === this.state.entegratorConf.identifier)
													&& (!this.props.currentUser.impersonate && this.state.informationMailCheck && (this.props.currentUser.informationMail === null)) &&
													<InformationMailModal
														informationMailChange={this.informationMailChange}
														informationMail={this.props.currentUser.informationMail}
														currentUser={this.props.currentUser}
														informationMailModal={this.state.informationMailCheck}
														isSmart={EntegratorIdentifiers.SMART === this.state.entegratorConf.identifier}
														toggleModal={() => this.setState({informationMailCheck: false})}
													/>}
												<hr style={{marginBottom: '10px', marginTop: '10px'}}></hr>
												{this.props.currentUser.adminUser &&
													<div className=" col-sm-12 row"
														 style={{margin: '0 0 0 0', padding: '0 0 0 0'}}>
														<Col sm='4'>
															<StickButton position="leftSide" className="stickButton"
																		 label="Kontör Geçmişi"
																		 labelClass='homePageLabelClass'
																		 onClick={() => this.showCreditHistory()}/>
														</Col>
														{(this.props.currentUser.entegrator && this.props.currentUser.adminUser) &&
															<Col sm='4'>
																<StickButton position="leftSide" className="stickButton"
																			 label="Faturalı Müşteriler"
																			 labelClass='homePageLabelClass'
																			 onClick={() => this.showPostpaidCustomerList()}/>
															</Col>
														}
														{this.checkShowBuyButton() &&
															<Col sm='4'>
																<StickButton position="leftSide" className="stickButton"
																			 label="Kontör Satın Al"
																			 labelClass='homePageLabelClass'
																			 onClick={() => this.setState({showPayTrModal: true})}/>
															</Col>
														}
														{(EntegratorIdentifiers.ZIRVE === this.state.entegratorConf.identifier || EntegratorIdentifiers.MIKROKOM === this.state.entegratorConf.identifier) &&
															<Col sm='4'>
																<StickButton position="leftSide" className="stickButton"
																			 label="Kontör Satın Al"
																			 labelClass='homePageLabelClass'
																			 onClick={() => (EntegratorIdentifiers.ZIRVE === this.state.entegratorConf.identifier) ? window.open(this.props.currentUser.paymentUrl, "_blank") : this.mikrokomHashBuyKontor()}/>
															</Col>
														}
													</div>}
											</div>
										</div>)}
								</div>
							</div>}
					</div>
						{!(this.state.contentList && this.state.contentList.length > 0) &&
							<div className="col-md-8 col-container" style={{marginTop: '20px'}}>
								<div className="card" style={this.props.decideVakifbankStyle()}>
									<div className="">
										<div className="card-header">
											<h4 className="card-title" style={{textTransform: 'uppercase'}}>{
												VirtualHost.conf.resourcePrefix === "datakontrol" ?
													"Ceo Programı yeni güncellemesi yayımlanmıştır. Detaylara aşağıdan ulaşabilirsiniz."
													: "Yenİ Web Sayfamız Yayında"}
											</h4>
										</div>
										<div className="card-body">
											<div className="row">
												<div className="col-sm-12">
													<Image className="simple-text logo-mini"
														 onClick={() => setTimeout(function () {
															 window.open(VirtualHost.conf.webSiteUrl, "_blank");
														 }, 100)}
														 src={SERVLET_PATH + "/api/virtual/resource/web.png"}
														 style={{
															 width: '100%',
															 height: '100%', paddingTop: '0px'
														 }}

													/>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						}

						{(this.state.contentList && this.state.contentList.length > 0) &&
							<div className="col-md-8 col-container" style={{marginTop: '20px'}}>
								<div className="card" style={this.props.decideVakifbankStyle()}>
									<div className="">
										<div className="col-md-12">
											<div style={{paddingTop: "10px", paddingBottom: "5px"}}>
												<Slider {...{
													dots: false,
													infinite: true,
													autoplay: true,
													autoplaySpeed: 5000,
													arrows: true,
													adaptiveHeight: true,
													cssEase: "linear",
													speed: 8000,
													slidesToShow: 1,
													slidesToScroll: 1
												}}>
													{this.state.contentList.map((content) =>
														<div>
															<div dangerouslySetInnerHTML={{__html: purify.sanitize(content)}}/>
														</div>
													)}
												</Slider>
											</div>
										</div>
									</div>
								</div>
							</div>
						}

						<div className=" col-md-4  col-container" style={{marginTop: '20px'}}>
							<div className=" card" style={this.props.decideVakifbankStyle()}>
								<div className="">
									<div className="card-header">
										<h4 className="card-title" style={{textTransform: 'uppercase'}}>TCMB
											Dövİz
											Kurları</h4>
									</div>
									<div className="card-body">
										<div className=" row">
											<div className="col-sm-12">
												<Image className="simple-text logo-mini "
													 src={process.env.REACT_APP_CONTEXT_NAME + "/image/piyasa.jpg"}
													 style={{paddingTop: '0px', width: '100%', height: '100%'}}
												/>
											</div>
											<div className="col-12 col-sm-12 row dovizContainer">
												<div className="col-4 col-sm-4"></div>
												<div className="col-4 col-sm-4 dovizUstBaslik">ALIŞ</div>
												<div className="col-4 col-sm-4 dovizUstBaslik">SATIŞ</div>
											</div>
											<div className="col-12 col-sm-12 row dovizContainer">
												<div className="col-4 col-sm-4 dovizYanBaslik">USD</div>
												<div className="col-4 col-sm-4 dovizIcerik">
													{(this.state.dollarCurrency && this.state.dollarCurrency.ForexBuying) ? this.state.dollarCurrency.ForexBuying : ""}₺
												</div>
												<div className="col-4 col-sm-4 dovizIcerik">
													{(this.state.dollarCurrency && this.state.dollarCurrency.ForexSelling) ? this.state.dollarCurrency.ForexSelling : ""}₺
												</div>
											</div>
											<div className="col-12 col-sm-12 row dovizContainer">
												<div className="col-4 col-sm-4 dovizYanBaslik">EUR</div>
												<div className="col-4 col-sm-4 dovizIcerik">
													{(this.state.euroCurrency && this.state.euroCurrency.ForexBuying) ? this.state.euroCurrency.ForexBuying : ""}₺
												</div>
												<div className="col-4 col-sm-4 dovizIcerik">
													{(this.state.euroCurrency && this.state.euroCurrency.ForexSelling) ? this.state.euroCurrency.ForexSelling : ""}₺
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						{((this.isEDefterSaklama() || this.isEDefter()) && !(this.isEFatura() || this.isEArsiv() || this.isEMM() || this.isESMM())) &&
						<div className="col-md-4 col" style={{marginTop: '20px'}}>
							<div className="card" style={this.props.decideVakifbankStyle()}>
								<div className="">
									<div className="card-header">
										<h4 className="card-title">KALAN BAKİYENİZ</h4>
									</div>
									<div className="card-body" style={{padding: '3px 15px 10px 15px'}}>
										<hr style={{marginBottom: '10px', marginTop: '10px'}}></hr>
										<div className=" row">
											<div className="col-md-12">
												<div className=" col-md-12 row" style={{float: 'left'}}>
													<div className="col-sm-12">
														<label style={{
															fontSize: '16px',
															fontWeight: 'bold',
															whiteSpace: 'nowrap'
														}}> {defterUnitName(EntegratorConf.identifier)} Durumu
														</label>
													</div>
													<div className="col-sm-12 ">
														<label style={{fontSize: '13px', marginBottom: '5px'}}>Aktif
															Yük.
															{defterUnitName(EntegratorConf.identifier)}: {(this.state.totalLoadedMemory || this.state.totalLoadedMemory === 0) ? this.state.totalLoadedMemory : "..."}</label>
													</div>
													<div className="col-sm-12 ">
														<label style={{whiteSpace: 'nowrap'}}>{defterUnitName(EntegratorConf.identifier)} Durumu: {(this.state.kalanMemory || this.state.kalanMemory === 0) ? this.state.kalanMemory : "..."}</label>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						}

						{((this.props.isEntegrator || this.props.isDistributor) && showKolayAndSmart(EntegratorConf.identifier) && this.state.announcementList && this.state.announcementList.length > 0) &&
							<div className="col-md-12 col">
								<div className="card">
									<div className="">
										<div className="col-md-12">
											<div style={{paddingTop: "10px", paddingBottom: "5px"}}>
												<Slider {...{
													arrows: true,
													adaptiveHeight: true,
													cssEase: "linear",
													dots: false,
													infinite: true,
													speed: 500,
													slidesToShow: 1,
													slidesToScroll: 1
												}}>
													{this.state.announcementList.map((content, index) => (
														<div key={index}>
															<h6 style={{color: "#f96332"}}>{new Date(content.publicationDate).toLocaleDateString("tr-TR")}</h6>
															<div style={{fontSize: "14px"}} dangerouslySetInnerHTML={{ __html: purify.sanitize(content.announcement) }} />
														</div>
													))}
												</Slider>
											</div>
										</div>
									</div>
								</div>
							</div>}
					</div>
					{this.state.sgkAppointmentModal &&
						<SgkAppointmentModal modal={this.state.sgkAppointmentModal}
											 mandatoryAppointment={this.state.mandatoryAppointment}
											 title={this.isEczaciKart() ? "EczacıPos" : "KolayPos" + " Kurulum Randevu Bilgileri"}
											 appointmentMonth={this.state.appointmentMonth}
											 toggle={(sgkAppointmentModal,sgkAppointment)=>this.setState({sgkAppointmentModal,sgkAppointment,mandatoryAppointment:false})}
											 customerId={this.props.currentUser.customerId}
											 cancelAppointment={() => this.setState({cancelAppointmentOk: true})}
						/>
					}
					{this.state.sgkAppointment &&
						<SweetAlert show success
									confirmBtnText="Tamam"
									confirmBtnBsStyle="info"
									title=""
									onConfirm={() => this.setState({sgkAppointment: null})}
						>
							Randevunuz alınmıştır<br/> {moment(this.state.sgkAppointment.appointmentTime).format("DD-MM-YYYY")} tarihinde {moment(this.state.sgkAppointment.appointmentTime).format("HH:mm")} - {moment(this.state.sgkAppointment.appointmentTime).add(30,'minutes').format("HH:mm")} saatleri arası<br/>
							{this.state.sgkAppointment.phone} telefon numarasından size dönüş yapılacaktır.
						</SweetAlert>
					}
					{this.state.cancelAppointmentOk &&
						<SweetAlert show error
									confirmBtnText="Tamam"
									confirmBtnBsStyle="info"
									title=""
									onConfirm={() => this.setState({sgkAppointment: null, cancelAppointmentOk: false})}
						>
							Randevunuz iptal edilmiştir.
						</SweetAlert>
					}
					{(this.state.creditHistoryModal && this.props.currentUser.adminUser) &&
					<CreditHistoryModal isOpen={this.state.creditHistoryModal}
										toggle={this.closeCreditHistoryModal}
										isEntegrator={this.props.isEntegrator}
										isDistributor={this.props.isDistributor}
										from="HomePage"
										currentUser={this.props.currentUser}/>
					}
					{this.state.showSmmInfoModal &&
					<SmmmUserModal isOpen={this.state.showSmmInfoModal}
								   toggle={this.closeShowSmmInfoModal}
								   currentUser={this.props.currentUser}/>
					}
					{this.state.showBankModal &&
					<BankModal isOpen={this.state.showBankModal}
							   toggle={this.closeShowBankModal}
							   currentUser={this.props.currentUser}/>
					}

					{(this.state.optikInfoModal && this.props.currentUser.hasMesulMudur) &&
					<OptikInformationModal isOpen={this.state.optikInfoModal}
										   toggle={this.closeOptikInfoModal}
										   currentUser={this.props.currentUser}
										   optikInfoData={this.state.optikInfoData}/>
					}
					{(this.state.showRequiredFiledModal && !this.props.currentUser.impersonate) &&
					<CustomerRequiredFieldModal show={this.state.showRequiredFiledModal}
												requiredField={this.state.requiredField}
												toggle={() => this.setState({showRequiredFiledModal: false})}/>
					}

					{this.state.showChemistInformationModal && !this.props.currentUser.impersonate && this.props.currentUser.adminUser &&
						<ChemistInformationModal
							show={this.state.showChemistInformationModal}
							currentUser={this.props.currentUser}
							toggle={() => this.setState({showChemistInformationModal: false})}
						/>
					}

					{(this.state.showPayTrModal && this.props.currentUser.adminUser) &&
					<PayTrModal show={this.state.showPayTrModal}
								paytrDomain={this.props.currentUser.paytrDomain}
								resourcePrefix={VirtualHost.conf.resourcePrefix}
								parentCustomerId={this.props.currentUser.parentCustomerId}
								toggle={() => this.setState({showPayTrModal: false})}
								purchaseAlan={this.state.purchaseAlan}
								isCreditUser = {this.state.isCreditUser}
								isAreaUser = {this.state.isAreaUser}
					/>
					}
					{(this.state.showKontorYukleModal && !this.state.showRequiredFiledModal && !this.state.showSmmInfoModal) &&
					<SweetAlert warning
								confirmBtnText="Kontör Satın Al"
								confirmBtnBsStyle="primary"
								title="UYARI"
								onConfirm={() => this.setState({
									showKontorYukleModal: false,
									showPayTrModal: true
								})}
								onCancel={() => this.setState({showKontorYukleModal: false})}
					>
						{((show100000AsUnlimited(this.props.currentUser.parentCustomerId) || this.isGarantiBankCustomer()) && !["tdub","eczacikart"].includes(VirtualHost.conf.resourcePrefix))
							? 'Makbuz kesebilmeniz için kontör yüklemesi yapınız.'
							: 'Bakiyeniz yetersiz  kontör yüklemelisiniz.'}
					</SweetAlert>
					}
					{((this.state.showAlanYukleModal && !this.state.showRequiredFiledModal && !this.state.showSmmInfoModal && this.isOgo() && this.isEczaciKart())) &&
					<SweetAlert warning
								confirmBtnText={defterUnitName(EntegratorConf.identifier) + " Satın Al"}
								confirmBtnBsStyle="primary"
								cancelBtnText="Kapat"
								title="UYARI"
								onConfirm={() => this.setState({
									showAlanYukleModal: false,
									showPayTrModal: true,
									purchaseAlan: true,
								})}
								onCancel={() => this.setState({showAlanYukleModal: false})}
					>
						{'Bakiyeniz yetersiz  '+defterUnitName(EntegratorConf.identifier)+' yüklemelisiniz.'}
					</SweetAlert>
					}

					{(this.state.postpaidCustomerListModal) &&
					<PostpaidCustomerList history={this.props.history}
										  isOpen={this.state.postpaidCustomerListModal}
										  toggle={this.closePostpaidCustomerListModal}/>
					}

					<Modal show={this.state.callCenterModal} onHide={this.handleCloseCallCenterModal} size="lg">
						<Modal.Header closeButton>
							<h2 style={{marginBottom: '20px'}}>İLETİŞİM</h2>
						</Modal.Header>
						<Modal.Body>
							<div style={{
								width: '100%',
								display: 'flex',
								flexDirection: 'column',
								alignItems: 'center'
							}}>
								<div>
									<h4 style={{marginBottom: '5px'}}>Müşteri Hizmetleri</h4>
									<p>
										Telefon:
										{this.isBaro() && ' 0850 259 19 24'}
										{this.isEczaciKart() && ' 0850 259 98 08'}
										{this.isOgo() && ' 0850 259 96 06'}
										{this.isSmart() && ' 0850 259 93 93'}
										{this.isMusavir() && ' 0850 259 19 89'}
										{(this.isKolaysoft() || this.isTdub() || this.isEsmm() || this.isTurcef() || this.isMedikal()
											|| this.isIsitmeMerkezi() || this.isTestud() || this.isTemfed() || this.isMasfed()) && ' 0850 259 90 90'}
										{this.isMbtFatura() && "0 850 308 06 28"}

										{this.isKolaytest() && ' 0850 456 78 90'}
									</p>

									<h4 style={{marginBottom: '5px'}}>E-Posta Adresimiz (7/24 Online Destek)</h4>
									<p>
										İstek ve Talepleriniz İçin:
										{this.isBaro() && ' avukatdestek@kolaysoft.com.tr'}
										{this.isEczaciKart() && ' eczacidestek@kolaysoft.com.tr'}
										{this.isMusavir() && 'musavirdestek@kolaysoft.com.tr'}
										{this.isSmart() && 'destek@smartdonusum.com'}
										{(this.isKolaysoft() || this.isOgo() || this.isTdub() || this.isEsmm() || this.isTurcef()
											|| this.isMasfed() || this.isTemfed() || this.isKolaytest()) && ' destek@kolaysoft.com.tr'}
										{(this.isMedikal() || this.isIsitmeMerkezi() || this.isTestud()) && 'medikaldestek@kolaysoft.com.tr'}
										{this.isMbtFatura() && "destek@mbtteknoloji.com.tr"}
									</p>

									<h4 style={{marginBottom: '5px'}}>Uzaktan Bağlantı Desteği</h4>
									<p>
										Destek Ekibinin bilgisayarınıza uzaktan bağlantı sağlayarak size daha
										hızlı yardımcı olabilmesi için altta verilen resimli bağlantıdan
										indirebileceğiniz uzaktan masaüstü bağlantı uygulamasını bilgisayarınıza
										kurarak, kurulum yaptıktan sonra kullanıcı numaranız (AnyDesk bağlantı
										adresiniz) ile çağrı merkezimize ulaşabilirsiniz.
										Kullanıcı numaranız (AnyDesk bağlantı adresiniz) aşağıdaki resimde
										işaretlenmiş kısımdadır.
									</p>
								</div>

								<Image style={{width: '180px'}} src='image/anydesk-logo.png'/>
								<a href='https://anydesk.com' target="_blank">https://anydesk.com</a>
								<Image style={{width: '640px'}} src='image/anydesk-sample.png'/>
								<p>(Kurulum veya uzaktan yardım yazılımları konusunda sorun yaşıyorsanız lütfen
									sistem yöneticinize başvurunuz.)</p>
							</div>
						</Modal.Body>
					</Modal>
					{ this.state.edefterApplicationModal &&
					<EdefterApplicationModal
						currentUser = {this.props.currentUser}
						edefterApplicationModal = {this.state.edefterApplicationModal}
						close = {() => this.setState({edefterApplicationModal : false})}
						cancel = {() => this.setState({edefterApplicationModal: false})}
						refresh = {() => this.refreshPage()}
						showBody = {true}
					/>
					}
					{ this.state.edefterSecondCopyApplicationModal &&
					<EdefterSecondCopyApplicationModal
						currentUser = {this.props.currentUser}
						edefterSecondCopyApplicationModal = {this.state.edefterSecondCopyApplicationModal}
						close = {() => this.setState({edefterSecondCopyApplicationModal : false})}
						refresh = {() => this.refreshPage()}
						showBody = {true}
					/>
					}
					{false && showEdefterSecondCopyApplicationCard(this.state.entegratorConf.identifier, this.props.currentUser.parentCustomerId) && (this.isEDefterSaklama() || this.isEDefter()) && !this.isEDefterIkincilKopya() &&
					<EdefterSecondCopyApplicationModal
						currentUser = {this.props.currentUser}
						edefterSecondCopyApplicationModal = {this.props.autoShowDefterSecondCopyNotification}
						close = {this.props.disableAutoShowDefterSecondCopyNotification}
						refresh = {() => this.refreshPage()}
						showBody = {true}
					/>
					}
					{this.state.connectorPaymentModal &&
						<ConnectorPaymentModal modal={this.state.connectorPaymentModal}
											   toggle={(flag, manual) => this.setState({connectorPaymentModal: flag, manual:manual})}
											   connectionInfo={this.state.connectionInfo}
											   checkConnectorUpdated={true}
											   connectorAlert={this.state.connectorAlert}
											   checkConnectorInstallation={false}
											   expireDate={this.state.expireDate}
											   currentUser={this.props.currentUser}/>
					}
					{ this.state.showDeniedInboxWithError &&
					<DeniedInboxWithErrorList
						showDeniedInboxWithError = {this.state.showDeniedInboxWithError}
						close = {() => this.setState({showDeniedInboxWithError: false})}
						forHomePage = {true}
						outboxDeniedTotal = {this.state.outboxDeniedTotal}
						outboxDeniedContent = {this.state.outboxDeniedContent}
						source = {this.state.source}
					/>
					}
					{this.state.changeCepTelModal &&
						<TelephoneModal isOpen={this.state.changeCepTelModal}
						toggle={() => this.setState({changeCepTelModal : false})}
						currentUser={this.props.currentUser}
						customerSorumluCepTel={this.state.customerSorumluCepTel}/>
					}

					{this.state.selcukEczaCampaignModal && this.props.currentUser.adminUser && !this.props.currentUser.username.includes("_44") &&
					<Modal show={this.state.selcukEczaCampaignModal} size='md' backdrop='static'>
						<Modal.Header closeButton={false} style={{padding: '22px 25px'}}>Selçuk Ecza Deposu Kampanya Seçim Onayı</Modal.Header>
						<Modal.Body>
							<div>
								<div className="col-sm-12">
									<div className="col-sm-12">
										<label style={{fontWeight: 'bold'}}>
											Selçuk Ecza Deposunun yapmış olduğu e-dönüşüm kampanyasından faydalanmak istiyor musunuz?
										</label>
									</div>
									<div className="col-sm-8" style={{maxWidth: "none"}}>
										<div onChange={(e) =>{
											this.setState({selcukEczacampaignSelection:e.target.value})
										}}>
											<input type="radio" value="true" name="selcukEczacampaign"/> Evet <br/>
											<input type="radio" value="false" name="selcukEczacampaign"/> Hayır
										</div>
									</div>
								</div>
							</div>
						</Modal.Body>
						<ModalFooter>
							<div className="col-sm-12 row mx-auto">
								<div className="col-sm-12 " style={{textAlign:'right'}}>
									<button type="button" data-toggle="tooltip" data-placement="bottom"
											style={{
												background: 'linear-gradient(rgba(125, 125, 125, 0.57), rgb(111, 111, 111))',
												padding: '10px 54px 10px 23px'
											}}
											rel="tooltip" className='TekBtn vazgec btn-icon'
											onClick={this.confirmSelcukEczaCampaign}
									>
										Onayla
									</button>
								</div>
							</div>
						</ModalFooter>
					</Modal>
					}
					{this.state.chemistCampaignModal &&
					<Modal show={this.state.chemistCampaignModal} onHide={() => this.setState({chemistCampaignModal: false})} size='lg' backdrop='static'>
						<Modal.Header closeButton style={{padding: '22px 25px'}}>Kampanya Detayı</Modal.Header>
						<Modal.Body>
							<div className="col-sm-12 row mx-auto">
                                <Image src={"image/" +this.state.campaignLogo +".jpeg"}/>
							</div>
						</Modal.Body>
						<Modal.Footer>
							<div className="col-sm-12 row mx-auto">
								<div className="col-sm-12 " style={{textAlign: 'right'}}>
									<button type="button" data-toggle="tooltip" data-placement="bottom"
											style={{
												background: 'linear-gradient(rgba(125, 125, 125, 0.57), rgb(111, 111, 111))',
												padding: '10px 54px 10px 23px'
											}}
											rel="tooltip" className='TekBtn vazgec btn-icon'
											onClick={() => this.setState({chemistCampaignModal: false})}
									>
										Kapat
									</button>
								</div>
							</div>
						</Modal.Footer>
					</Modal>
					}

					{this.state.showEdefterApplicationVideoModal &&
					<VideoModal video={{id: "5bs8TFV3l54", title: "e-Defter aktivasyonu nasıl yapılır"}}
								isOpen={this.state.showEdefterApplicationVideoModal}
								close={() => this.setState({showEdefterApplicationVideoModal: false})}/>
					}

					{this.state.showBekKvkkModal &&
						<div style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
							<BekKvkkModal show={this.state.showBekKvkkModal}
									  close={() => this.setState({showBekKvkkModal: false})}/>
						</div>
					}

					{this.state.withoutAppointment && this.state.hasAppointmentModal && this.isEczaciKart() &&
						<Modal show={this.state.hasAppointmentModal}
							   onHide={() => this.setState({hasAppointmentModal: false, sgkAppointmentModal: true})}
							   size='m'
							   backdrop='static'>
							<Modal.Header style={{padding: '22px 25px'}}></Modal.Header>
							<Modal.Body>
								<div className="col-sm-12 row mx-auto">
									<div style={{fontSize: '17px'}}>
										Değerli {this.isEczaciKart() ? "Eczacım" : "Müşterimiz"},<br/>
										{this.isEczaciKart() ? "EczacıPos" : "KolayPos"} elinize ulaşmıştır. VUK 507 geçişinizi tamamlamak adına kurulumunuzu yaptırmanız gerekmektedir.
										Güncel randevu kurulum tarih / saatine aşağıdan ulaşabilirsiniz.
									</div>
								</div>
							</Modal.Body>
							<Modal.Footer style={{justifyContent: 'center'}}>
								<button type="button"
										data-toggle="tooltip"
										data-placement="bottom"
										style={{
											background: 'linear-gradient(rgba(159, 208, 55, 0.6), #9fd037)',
											padding: '10px 54px 10px 23px',
											border: 'none',
											color: '#fff'
										}}
										rel="tooltip"
										className='TekBtn kaydet btn-icon'
										onClick={() => this.setState({hasAppointmentModal: false, sgkAppointmentModal: true})}>
									Tamam
								</button>
							</Modal.Footer>
						</Modal>
					}
					{this.state.posApprovedModal &&
						<Modal show={true} size='md' backdrop='static'>
							<Modal.Header closeButton={false} style={{padding: '22px 25px'}}>POS CİHAZI KURULUM ONAYI</Modal.Header>
							<Modal.Body>
								<div>
									<div className="col-sm-12">
										<div className="col-sm-12">
											<label style={{fontWeight: 'bold'}}>
												"{vukApplicationList.filter(f => f.sponsorName === "TEB")[0].vukApplicationNo}" POS CİHAZINIZIN KURULUMU TAMAMLANDI MI?
											</label>
										</div>
										<div className="col-sm-8" style={{maxWidth: "none"}}>
											<div onChange={(e) =>{
												this.setState({posApprovedCheckSelection: e.target.value})
											}}>
												<input type="radio" value={true} name="selcukEczacampaign"/> Evet <br/>
												<input type="radio" value={false} name="selcukEczacampaign"/> Hayır
											</div>
										</div>
									</div>
								</div>
							</Modal.Body>
							<ModalFooter>
								<div className="col-sm-12 row mx-auto">
									<div className="col-sm-12" style={{textAlign:'right'}}>
										<button type="button"
												data-toggle="tooltip" data-placement="bottom"
												style={{
													background: 'linear-gradient(rgba(125, 125, 125, 0.57), rgb(111, 111, 111))',
													padding: '10px 54px 10px 23px'
												}}
												rel="tooltip" className='TekBtn vazgec btn-icon'
												onClick={this.approvedPosCheck}
												disabled={this.state.posApprovedCheckSelection == null}
										>
											Onayla
										</button>
									</div>
								</div>
							</ModalFooter>
						</Modal>
					}

					{showServiceFeeModal &&
						<Modal show={true} size='md' backdrop='static' onHide={() => this.setState({ showServiceFeeModal: false })}>
							<Modal.Header closeButton>
								<h5>{showKolaysoftPos(this.props.currentUser.parentCustomerId, this.state.entegratorConf.vuk507PosApplicationUrl) ? "KolaysoftPos" : "EczacıPos"} {this.state.eczaciposPaymentInfo.title}</h5>
							</Modal.Header>
							<Modal.Body>
								{showKolaysoftPos(this.props.currentUser.parentCustomerId, this.state.entegratorConf.vuk507PosApplicationUrl) ?
									<p>Bekleyen Yıllık Hizmet Bedeli Ödemeniz Bulunmaktadır.<strong>Ödeme Yapmak İçin Lütfen Aşağıdaki Butona Tıklayın.</strong></p>
									:
									<img src={this.state.eczaciposPaymentInfo.img}/>
								}
							</Modal.Body>
							<Modal.Footer style={{ justifyContent: 'flex-end' }}>
								<button
									type="button"
									className="btn btn-success"
									onClick={() => this.redirectToPayment()}
								>
									Şimdi Öde
								</button>
							</Modal.Footer>
						</Modal>
					}

					{this.state.showTimeline && this.state.selectedTimeline && this.props.currentUser.entegrator &&
						<Modal size={this.state.selectedTimeline.description.length > 55 ? 'lg' : 'm'}
							   show={this.state.showTimeline} onHide={this.handleCloseModal}>
							<Modal.Header closeButton>
								<Modal.Title>{this.state.selectedTimeline.title}</Modal.Title>
							</Modal.Header>
							<Modal.Body>
								<div dangerouslySetInnerHTML={{ __html: this.state.selectedTimeline.description }}/>
							</Modal.Body>
							<Modal.Footer style={{justifyContent: 'center'}}>
								<button type="button"
										data-toggle="tooltip"
										data-placement="bottom"
										style={{
											background: 'linear-gradient(rgba(159, 208, 55, 0.6), #9fd037)',
											padding: '10px 54px 10px 23px',
											border: 'none',
											color: '#fff'
										}}
										rel="tooltip"
										className='TekBtn kaydet btn-icon'
										onClick={this.handleCloseModal}>
									Tamam
								</button>
							</Modal.Footer>
						</Modal>
					}
				</div>
			);
	}
}
export default HomePage;
